export const countries = [
  {
    name: "Afghanistan",
    phoneCode: "+93",
    alpha2code: "AF",
    alpha3code: "AFG",
  },
  {
    name: "Albania",
    phoneCode: "+355",
    alpha2code: "AL",
    alpha3code: "ALB",
  },
  {
    name: "Algeria",
    phoneCode: "+213",
    alpha2code: "DZ",
    alpha3code: "DZA",
  },
  {
    name: "American Samoa",
    phoneCode: "+1",
    alpha2code: "AS",
    alpha3code: "ASM",
  },
  {
    name: "Andorra",
    phoneCode: "+376",
    alpha2code: "AD",
    alpha3code: "AND",
  },
  {
    name: "Angola",
    phoneCode: "+244",
    alpha2code: "AO",
    alpha3code: "AGO",
  },
  {
    name: "Anguilla",
    phoneCode: "+1",
    alpha2code: "AI",
    alpha3code: "AIA",
  },
  {
    name: "Antigua and Barbuda",
    phoneCode: "+1",
    alpha2code: "AG",
    alpha3code: "ATG",
  },
  {
    name: "Argentina",
    phoneCode: "+54",
    alpha2code: "AR",
    alpha3code: "ARG",
  },
  {
    name: "Armenia",
    phoneCode: "+374",
    alpha2code: "AM",
    alpha3code: "ARM",
  },
  {
    name: "Aruba",
    phoneCode: "+297",
    alpha2code: "AW",
    alpha3code: "ABW",
  },
  {
    name: "Australia",
    phoneCode: "+61",
    alpha2code: "AU",
    alpha3code: "AUS",
  },
  {
    name: "Austria",
    phoneCode: "+43",
    alpha2code: "AT",
    alpha3code: "AUT",
  },
  {
    name: "Azerbaijan",
    phoneCode: "+994",
    alpha2code: "AZ",
    alpha3code: "AZE",
  },
  {
    name: "Bahrain",
    phoneCode: "+973",
    alpha2code: "BH",
    alpha3code: "BHR",
  },
  {
    name: "Bangladesh",
    phoneCode: "+880",
    alpha2code: "BD",
    alpha3code: "BGD",
  },
  {
    name: "Barbados",
    phoneCode: "+1",
    alpha2code: "BB",
    alpha3code: "BRB",
  },
  {
    name: "Belarus",
    phoneCode: "+375",
    alpha2code: "BY",
    alpha3code: "BLR",
  },
  {
    name: "Belgium",
    phoneCode: "+32",
    alpha2code: "BE",
    alpha3code: "BEL",
  },
  {
    name: "Belize",
    phoneCode: "+501",
    alpha2code: "BZ",
    alpha3code: "BLZ",
  },
  {
    name: "Benin",
    phoneCode: "+229",
    alpha2code: "BJ",
    alpha3code: "BEN",
  },
  {
    name: "Bermuda",
    phoneCode: "+1",
    alpha2code: "BM",
    alpha3code: "BMU",
  },
  {
    name: "Bhutan",
    phoneCode: "+975",
    alpha2code: "BT",
    alpha3code: "BTN",
  },
  {
    name: "Bolivia",
    phoneCode: "+591",
    alpha2code: "BO",
    alpha3code: "BOL",
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    phoneCode: "+599",
    alpha2code: "BQ",
    alpha3code: "BES",
  },
  {
    name: "Bosnia and Herzegovina",
    phoneCode: "+387",
    alpha2code: "BA",
    alpha3code: "BIH",
  },
  {
    name: "Botswana",
    phoneCode: "+267",
    alpha2code: "BW",
    alpha3code: "BWA",
  },
  {
    name: "Brazil",
    phoneCode: "+55",
    alpha2code: "BR",
    alpha3code: "BRA",
  },
  {
    name: "British Indian Ocean Territory",
    phoneCode: "+246",
    alpha2code: "IO",
    alpha3code: "IOT",
  },
  {
    name: "British Virgin Islands",
    phoneCode: "+1",
    alpha2code: "VG",
    alpha3code: "VGB",
  },
  {
    name: "Brunei Darussalam",
    phoneCode: "+673",
    alpha2code: "BN",
    alpha3code: "BRN",
  },
  {
    name: "Bulgaria",
    phoneCode: "+359",
    alpha2code: "BG",
    alpha3code: "BGR",
  },
  {
    name: "Burkina Faso",
    phoneCode: "+226",
    alpha2code: "BF",
    alpha3code: "BFA",
  },
  {
    name: "Myanmar",
    phoneCode: "+95",
    alpha2code: "MM",
    alpha3code: "MMR",
  },
  {
    name: "Burundi",
    phoneCode: "+257",
    alpha2code: "BI",
    alpha3code: "BDI",
  },
  {
    name: "Cambodia",
    phoneCode: "+855",
    alpha2code: "KH",
    alpha3code: "KHM",
  },
  {
    name: "Cameroon",
    phoneCode: "+237",
    alpha2code: "CM",
    alpha3code: "CMR",
  },
  {
    name: "Canada",
    phoneCode: "+1",
    alpha2code: "CA",
    alpha3code: "CAN",
  },
  {
    name: "Cabo Verde",
    phoneCode: "+238",
    alpha2code: "CV",
    alpha3code: "CPV",
  },
  {
    name: "Cayman Islands",
    phoneCode: "+1",
    alpha2code: "KY",
    alpha3code: "CYM",
  },
  {
    name: "Central African Republic",
    phoneCode: "+236",
    alpha2code: "CF",
    alpha3code: "CAF",
  },
  {
    name: "Chad",
    phoneCode: "+235",
    alpha2code: "ID",
    alpha3code: "TCD",
  },
  {
    name: "Chile",
    phoneCode: "+56",
    alpha2code: "CL",
    alpha3code: "CHL",
  },
  {
    name: "China",
    phoneCode: "+86",
    alpha2code: "CN",
    alpha3code: "CHN",
  },
  {
    name: "Colombia",
    phoneCode: "+57",
    alpha2code: "CO",
    alpha3code: "COL",
  },
  {
    name: "Comoros",
    phoneCode: "+269",
    alpha2code: "KM",
    alpha3code: "COM",
  },
  {
    name: "Cook Islands",
    phoneCode: "+682",
    alpha2code: "CK",
    alpha3code: "COK",
  },
  {
    name: "Costa Rica",
    phoneCode: "+506",
    alpha2code: "CR",
    alpha3code: "CRI",
  },
  {
    name: "Côte dIvoire",
    phoneCode: "+225",
    alpha2code: "CI",
    alpha3code: "CIV",
  },
  {
    name: "Croatia",
    phoneCode: "+385",
    alpha2code: "HR",
    alpha3code: "HRV",
  },
  {
    name: "Cuba",
    phoneCode: "+53",
    alpha2code: "CU",
    alpha3code: "CUB",
  },
  {
    name: "Curaçao",
    phoneCode: "+599",
    alpha2code: "CW",
    alpha3code: "CUW",
  },
  {
    name: "Cyprus",
    phoneCode: "+357",
    alpha2code: "CY",
    alpha3code: "CYP",
  },
  {
    name: "Czechia",
    phoneCode: "+420",
    alpha2code: "CZ",
    alpha3code: "CZE",
  },
  {
    name: "Denmark",
    phoneCode: "+45",
    alpha2code: "DK",
    alpha3code: "DNK",
  },
  {
    name: "Djibouti",
    phoneCode: "+253",
    alpha2code: "DJ",
    alpha3code: "DJI",
  },
  {
    name: "Dominica",
    phoneCode: "+1",
    alpha2code: "DM",
    alpha3code: "DMA",
  },
  {
    name: "Dominican Republic",
    phoneCode: "+1",
    alpha2code: "DO",
    alpha3code: "DOM",
  },
  {
    name: "Ecuador",
    phoneCode: "+593",
    alpha2code: "EC",
    alpha3code: "ECU",
  },
  {
    name: "Egypt",
    phoneCode: "+20",
    alpha2code: "EG",
    alpha3code: "EGY",
  },
  {
    name: "El Salvador",
    phoneCode: "+503",
    alpha2code: "SV",
    alpha3code: "SLV",
  },
  {
    name: "Equatorial Guinea",
    phoneCode: "+240",
    alpha2code: "GQ",
    alpha3code: "GNQ",
  },
  {
    name: "Eritrea",
    phoneCode: "+291",
    alpha2code: "ER",
    alpha3code: "ERI",
  },
  {
    name: "Estonia",
    phoneCode: "+372",
    alpha2code: "EE",
    alpha3code: "EST",
  },
  {
    name: "Ethiopia",
    phoneCode: "+251",
    alpha2code: "ET",
    alpha3code: "ETH",
  },
  {
    name: "Falkland Islands",
    phoneCode: "+500",
    alpha2code: "FK",
    alpha3code: "FLK",
  },
  {
    name: "Faroe Islands",
    phoneCode: "+298",
    alpha2code: "FO",
    alpha3code: "FRO",
  },
  {
    name: "Federated States of Micronesia",
    phoneCode: "+691",
    alpha2code: "FM",
    alpha3code: "FSM",
  },
  {
    name: "Fiji",
    phoneCode: "+679",
    alpha2code: "FJ",
    alpha3code: "FJI",
  },
  {
    name: "Finland",
    phoneCode: "+358",
    alpha2code: "FI",
    alpha3code: "FIN",
  },
  {
    name: "France",
    phoneCode: "+33",
    alpha2code: "FR",
    alpha3code: "FRA",
  },
  {
    name: "French Guiana",
    phoneCode: "+594",
    alpha2code: "GF",
    alpha3code: "GUF",
  },
  {
    name: "French Polynesia",
    phoneCode: "+689",
    alpha2code: "PF",
    alpha3code: "PYF",
  },
  {
    name: "Gabon",
    phoneCode: "+241",
    alpha2code: "GA",
    alpha3code: "GAB",
  },
  {
    name: "Georgia",
    phoneCode: "+995",
    alpha2code: "GE",
    alpha3code: "GEO",
  },
  {
    name: "Germany",
    phoneCode: "+49",
    alpha2code: "DE",
    alpha3code: "DEU",
  },
  {
    name: "Ghana",
    phoneCode: "+233",
    alpha2code: "GH",
    alpha3code: "GHA",
  },
  {
    name: "Gibraltar",
    phoneCode: "+350",
    alpha2code: "GI",
    alpha3code: "GIB",
  },
  {
    name: "Greece",
    phoneCode: "+30",
    alpha2code: "GR",
    alpha3code: "GRC",
  },
  {
    name: "Greenland",
    phoneCode: "+299",
    alpha2code: "GL",
    alpha3code: "GRL",
  },
  {
    name: "Grenada",
    phoneCode: "+1",
    alpha2code: "GD",
    alpha3code: "GRD",
  },
  {
    name: "Guadeloupe",
    phoneCode: "+590",
    alpha2code: "GP",
    alpha3code: "GLP",
  },
  {
    name: "Guam",
    phoneCode: "+1",
    alpha2code: "GU",
    alpha3code: "GUM",
  },
  {
    name: "Guatemala",
    phoneCode: "+502",
    alpha2code: "GT",
    alpha3code: "GTM",
  },
  {
    name: "Guinea",
    phoneCode: "+224",
    alpha2code: "GN",
    alpha3code: "GIN",
  },
  {
    name: "Guinea-Bissau",
    phoneCode: "+245",
    alpha2code: "GW",
    alpha3code: "GNB",
  },
  {
    name: "Guyana",
    phoneCode: "+592",
    alpha2code: "GY",
    alpha3code: "GUY",
  },
  {
    name: "Haiti",
    phoneCode: "+509",
    alpha2code: "HT",
    alpha3code: "HTI",
  },
  {
    name: "Honduras",
    phoneCode: "+504",
    alpha2code: "HN",
    alpha3code: "HND",
  },
  {
    name: "Hong Kong",
    phoneCode: "+852",
    alpha2code: "HK",
    alpha3code: "HKG",
  },
  {
    name: "Hungary",
    phoneCode: "+36",
    alpha2code: "HU",
    alpha3code: "HUN",
  },
  {
    name: "Iceland",
    phoneCode: "+354",
    alpha2code: "IS",
    alpha3code: "ISL",
  },
  {
    name: "India",
    phoneCode: "+91",
    alpha2code: "IN",
    alpha3code: "IND",
  },
  {
    name: "Indonesia",
    phoneCode: "+62",
    alpha2code: "ID",
    alpha3code: "IDN",
  },
  {
    name: "Iran",
    phoneCode: "+98",
    alpha2code: "IR",
    alpha3code: "IRN",
  },
  {
    name: "Iraq",
    phoneCode: "+964",
    alpha2code: "IQ",
    alpha3code: "IRQ",
  },
  {
    name: "Ireland",
    phoneCode: "+353",
    alpha2code: "IE",
    alpha3code: "IRL",
  },
  {
    name: "Israel",
    phoneCode: "+972",
    alpha2code: "IL",
    alpha3code: "ISR",
  },
  {
    name: "Italy",
    phoneCode: "+39",
    alpha2code: "IT",
    alpha3code: "ITA",
  },
  {
    name: "Jamaica",
    phoneCode: "+1",
    alpha2code: "JM",
    alpha3code: "JAM",
  },
  {
    name: "Japan",
    phoneCode: "+81",
    alpha2code: "JP",
    alpha3code: "JPN",
  },
  {
    name: "Jordan",
    phoneCode: "+962",
    alpha2code: "JO",
    alpha3code: "JOR",
  },
  {
    name: "Kazakhstan",
    phoneCode: "+7",
    alpha2code: "KZ",
    alpha3code: "KAZ",
  },
  {
    name: "Kenya",
    phoneCode: "+254",
    alpha2code: "KE",
    alpha3code: "KEN",
  },
  {
    name: "Kiribati",
    phoneCode: "+686",
    alpha2code: "KI",
    alpha3code: "KIR",
  },
  {
    name: "Kuwait",
    phoneCode: "+965",
    alpha2code: "KW",
    alpha3code: "KWT",
  },
  {
    name: "Kyrgyzstan",
    phoneCode: "+996",
    alpha2code: "KG",
    alpha3code: "KGZ",
  },
  {
    name: "Laos",
    phoneCode: "+856",
    alpha2code: "LA",
    alpha3code: "LAO",
  },
  {
    name: "Latvia",
    phoneCode: "+371",
    alpha2code: "LV",
    alpha3code: "LVA",
  },
  {
    name: "Lebanon",
    phoneCode: "+961",
    alpha2code: "LB",
    alpha3code: "LBN",
  },
  {
    name: "Lesotho",
    phoneCode: "+266",
    alpha2code: "LS",
    alpha3code: "LSO",
  },
  {
    name: "Liberia",
    phoneCode: "+231",
    alpha2code: "LR",
    alpha3code: "LBR",
  },
  {
    name: "Libya",
    phoneCode: "+218",
    alpha2code: "LY",
    alpha3code: "LBY",
  },
  {
    name: "Liechtenstein",
    phoneCode: "+423",
    alpha2code: "LI",
    alpha3code: "LIE",
  },
  {
    name: "Lithuania",
    phoneCode: "+370",
    alpha2code: "LT",
    alpha3code: "LTU",
  },
  {
    name: "Luxembourg",
    phoneCode: "+352",
    alpha2code: "LU",
    alpha3code: "LUX",
  },
  {
    name: "Macao",
    phoneCode: "+853",
    alpha2code: "MO",
    alpha3code: "MAC",
  },
  {
    name: "Macedonia",
    phoneCode: "+389",
    alpha2code: "MK",
    alpha3code: "MKD",
  },
  {
    name: "Madagascar",
    phoneCode: "+261",
    alpha2code: "MG",
    alpha3code: "MDG",
  },
  {
    name: "Malawi",
    phoneCode: "+265",
    alpha2code: "MW",
    alpha3code: "MWI",
  },
  {
    name: "Malaysia",
    phoneCode: "+60",
    alpha2code: "MY",
    alpha3code: "MYS",
  },
  {
    name: "Maldives",
    phoneCode: "+960",
    alpha2code: "MV",
    alpha3code: "MDV",
  },
  {
    name: "Mali",
    phoneCode: "+223",
    alpha2code: "ML",
    alpha3code: "MLI",
  },
  {
    name: "Malta",
    phoneCode: "+356",
    alpha2code: "MT",
    alpha3code: "MLT",
  },
  {
    name: "Marshall Islands",
    phoneCode: "+692",
    alpha2code: "MH",
    alpha3code: "MHL",
  },
  {
    name: "Martinique",
    phoneCode: "+596",
    alpha2code: "MQ",
    alpha3code: "MTQ",
  },
  {
    name: "Mauritania",
    phoneCode: "+222",
    alpha2code: "MR",
    alpha3code: "MRT",
  },
  {
    name: "Mauritius",
    phoneCode: "+230",
    alpha2code: "MU",
    alpha3code: "MUS",
  },
  {
    name: "Mayotte",
    phoneCode: "+262",
    alpha2code: "YT",
    alpha3code: "MYT",
  },
  {
    name: "Mexico",
    phoneCode: "+52",
    alpha2code: "MX",
    alpha3code: "MEX",
  },
  {
    name: "Moldova",
    phoneCode: "+373",
    alpha2code: "MD",
    alpha3code: "MDA",
  },
  {
    name: "Monaco",
    phoneCode: "+377",
    alpha2code: "MC",
    alpha3code: "MCO",
  },
  {
    name: "Mongolia",
    phoneCode: "+976",
    alpha2code: "MN",
    alpha3code: "MNG",
  },
  {
    name: "Montenegro",
    phoneCode: "+382",
    alpha2code: "ME",
    alpha3code: "MNE",
  },
  {
    name: "Montserrat",
    phoneCode: "+1",
    alpha2code: "MS",
    alpha3code: "MSR",
  },
  {
    name: "Morocco",
    phoneCode: "+212",
    alpha2code: "MA",
    alpha3code: "MAR",
  },
  {
    name: "Mozambique",
    phoneCode: "+258",
    alpha2code: "MZ",
    alpha3code: "MOZ",
  },
  {
    name: "Namibia",
    phoneCode: "+264",
    alpha2code: "NA",
    alpha3code: "NAM",
  },
  {
    name: "Nauru",
    phoneCode: "+674",
    alpha2code: "NR",
    alpha3code: "NRU",
  },
  {
    name: "Nepal",
    phoneCode: "+977",
    alpha2code: "NP",
    alpha3code: "NPL",
  },
  {
    name: "Netherlands",
    phoneCode: "+31",
    alpha2code: "NL",
    alpha3code: "NLD",
  },
  {
    name: "Netherlands Antilles",
    phoneCode: "+599",
    alpha2code: "AN",
    alpha3code: "ANT",
  },
  {
    name: "New Caledonia",
    phoneCode: "+687",
    alpha2code: "NC",
    alpha3code: "NCL",
  },
  {
    name: "New Zealand",
    phoneCode: "+64",
    alpha2code: "NZ",
    alpha3code: "NZL",
  },
  {
    name: "Nicaragua",
    phoneCode: "+505",
    alpha2code: "NI",
    alpha3code: "NIC",
  },
  {
    name: "Niger",
    phoneCode: "+227",
    alpha2code: "NE",
    alpha3code: "NER",
  },
  {
    name: "Nigeria",
    phoneCode: "+234",
    alpha2code: "NG",
    alpha3code: "NGA",
  },
  {
    name: "Niue",
    phoneCode: "+683",
    alpha2code: "NU",
    alpha3code: "NIU",
  },
  {
    name: "Norfolk Island",
    phoneCode: "+672",
    alpha2code: "NF",
    alpha3code: "NFK",
  },
  {
    name: "North Korea",
    phoneCode: "+850",
    alpha2code: "KP",
    alpha3code: "PRK",
  },
  {
    name: "Northern Mariana Islands",
    phoneCode: "+1",
    alpha2code: "MP",
    alpha3code: "MNP",
  },
  {
    name: "Norway",
    phoneCode: "+47",
    alpha2code: "NO",
    alpha3code: "NOR",
  },
  {
    name: "Oman",
    phoneCode: "+968",
    alpha2code: "OM",
    alpha3code: "OMN",
  },
  {
    name: "Pakistan",
    phoneCode: "+92",
    alpha2code: "PK",
    alpha3code: "PAK",
  },
  {
    name: "Palau",
    phoneCode: "+680",
    alpha2code: "PW",
    alpha3code: "PLW",
  },
  {
    name: "Palestine",
    phoneCode: "+970",
    alpha2code: "PS",
    alpha3code: "PSE",
  },
  {
    name: "Panama",
    phoneCode: "+507",
    alpha2code: "PA",
    alpha3code: "PAN",
  },
  {
    name: "Papua New Guinea",
    phoneCode: "+675",
    alpha2code: "PG",
    alpha3code: "PNG",
  },
  {
    name: "Paraguay",
    phoneCode: "+595",
    alpha2code: "PY",
    alpha3code: "PRY",
  },
  {
    name: "Peru",
    phoneCode: "+51",
    alpha2code: "PE",
    alpha3code: "PER",
  },
  {
    name: "Philippines",
    phoneCode: "+63",
    alpha2code: "PH",
    alpha3code: "PHL",
  },
  {
    name: "Poland",
    phoneCode: "+48",
    alpha2code: "PL",
    alpha3code: "POL",
  },
  {
    name: "Portugal",
    phoneCode: "+351",
    alpha2code: "PT",
    alpha3code: "PRT",
  },
  {
    name: "Puerto Rico",
    phoneCode: "+1",
    alpha2code: "PR",
    alpha3code: "PRI",
  },
  {
    name: "Qatar",
    phoneCode: "+974",
    alpha2code: "QA",
    alpha3code: "QAT",
  },
  {
    name: "Congo",
    phoneCode: "+242",
    alpha2code: "CG",
    alpha3code: "COG",
  },
  {
    name: "Réunion",
    phoneCode: "+262",
    alpha2code: "RE",
    alpha3code: "REU",
  },
  {
    name: "Romania",
    phoneCode: "+40",
    alpha2code: "RO",
    alpha3code: "ROU",
  },
  {
    name: "Russia",
    phoneCode: "+7",
    alpha2code: "RU",
    alpha3code: "RUS",
  },
  {
    name: "Rwanda",
    phoneCode: "+250",
    alpha2code: "RW",
    alpha3code: "RWA",
  },
  {
    name: "Saint Barthélemy",
    phoneCode: "+590",
    alpha2code: "BL",
    alpha3code: "BLM",
  },
  {
    name: "Saint Helena",
    phoneCode: "+290",
    alpha2code: "SH",
    alpha3code: "SHN",
  },
  {
    name: "Saint Kitts and Nevis",
    phoneCode: "+1",
    alpha2code: "KN",
    alpha3code: "KNA",
  },
  {
    name: "Saint Martin",
    phoneCode: "+590",
    alpha2code: "MF",
    alpha3code: "MAF",
  },
  {
    name: "Saint Pierre and Miquelon",
    phoneCode: "+508",
    alpha2code: "PM",
    alpha3code: "SPM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    phoneCode: "+1",
    alpha2code: "VC",
    alpha3code: "VCT",
  },
  {
    name: "Samoa",
    phoneCode: "+685",
    alpha2code: "WS",
    alpha3code: "WSM",
  },
  {
    name: "San Marino",
    phoneCode: "+378",
    alpha2code: "SM",
    alpha3code: "SMR",
  },
  {
    name: "São Tomé and Príncipe",
    phoneCode: "+239",
    alpha2code: "ST",
    alpha3code: "STP",
  },
  {
    name: "Saudi Arabia",
    phoneCode: "+966",
    alpha2code: "SA",
    alpha3code: "SAU",
  },
  {
    name: "Senegal",
    phoneCode: "+221",
    alpha2code: "SN",
    alpha3code: "SEN",
  },
  {
    name: "Serbia",
    phoneCode: "+381",
    alpha2code: "RS",
    alpha3code: "SRB",
  },
  {
    name: "Seychelles",
    phoneCode: "+248",
    alpha2code: "SC",
    alpha3code: "SYC",
  },
  {
    name: "Sierra Leone",
    phoneCode: "+232",
    alpha2code: "SL",
    alpha3code: "SLE",
  },
  {
    name: "Singapore",
    phoneCode: "+65",
    alpha2code: "SG",
    alpha3code: "SGP",
  },
  {
    name: "Sint Maarten (Dutch part)",
    phoneCode: "+1",
    alpha2code: "SX",
    alpha3code: "SXM",
  },
  {
    name: "Slovakia",
    phoneCode: "+421",
    alpha2code: "SK",
    alpha3code: "SVK",
  },
  {
    name: "Slovenia",
    phoneCode: "+386",
    alpha2code: "SI",
    alpha3code: "SVN",
  },
  {
    name: "Solomon Islands",
    phoneCode: "+677",
    alpha2code: "SB",
    alpha3code: "SLB",
  },
  {
    name: "Somalia",
    phoneCode: "+252",
    alpha2code: "SO",
    alpha3code: "SOM",
  },
  {
    name: "South Africa",
    phoneCode: "+27",
    alpha2code: "ZA",
    alpha3code: "ZAF",
  },
  {
    name: "South Korea",
    phoneCode: "+82",
    alpha2code: "KR",
    alpha3code: "KOR",
  },
  {
    name: "South Sudan",
    phoneCode: "+211",
    alpha2code: "SS",
    alpha3code: "SSD",
  },
  {
    name: "Spain",
    phoneCode: "+34",
    alpha2code: "ES",
    alpha3code: "ESP",
  },
  {
    name: "Sri Lanka",
    phoneCode: "+94",
    alpha2code: "LK",
    alpha3code: "LKA",
  },
  {
    name: "Saint Lucia",
    phoneCode: "+1",
    alpha2code: "LC",
    alpha3code: "LCA",
  },
  {
    name: "Sudan",
    phoneCode: "+249",
    alpha2code: "SD",
    alpha3code: "SDN",
  },
  {
    name: "Suriname",
    phoneCode: "+597",
    alpha2code: "SR",
    alpha3code: "SUR",
  },
  {
    name: "Swaziland",
    phoneCode: "+268",
    alpha2code: "SZ",
    alpha3code: "SWZ",
  },
  {
    name: "Sweden",
    phoneCode: "+46",
    alpha2code: "SE",
    alpha3code: "SWE",
  },
  {
    name: "Switzerland",
    phoneCode: "+41",
    alpha2code: "CH",
    alpha3code: "CHE",
  },
  {
    name: "Syrian Arab Republic",
    phoneCode: "+963",
    alpha2code: "SY",
    alpha3code: "SYR",
  },
  {
    name: "Taiwan",
    phoneCode: "+886",
    alpha2code: "TW",
    alpha3code: "TWN",
  },
  {
    name: "Tajikistan",
    phoneCode: "+992",
    alpha2code: "TJ",
    alpha3code: "TJK",
  },
  {
    name: "Tanzania",
    phoneCode: "+255",
    alpha2code: "TZ",
    alpha3code: "TZA",
  },
  {
    name: "Thailand",
    phoneCode: "+66",
    alpha2code: "TH",
    alpha3code: "THA",
  },
  {
    name: "Bahamas",
    phoneCode: "+1",
    alpha2code: "BS",
    alpha3code: "BHS",
  },
  {
    name: "Gambia",
    phoneCode: "+220",
    alpha2code: "GM",
    alpha3code: "GMB",
  },
  {
    name: "Timor-Leste",
    phoneCode: "+670",
    alpha2code: "TL",
    alpha3code: "TLS",
  },
  {
    name: "Togo",
    phoneCode: "+228",
    alpha2code: "TG",
    alpha3code: "TGO",
  },
  {
    name: "Tokelau",
    phoneCode: "+690",
    alpha2code: "TK",
    alpha3code: "TKL",
  },
  {
    name: "Tonga",
    phoneCode: "+676",
    alpha2code: "TO",
    alpha3code: "TON",
  },
  {
    name: "Trinidad and Tobago",
    phoneCode: "+1",
    alpha2code: "TT",
    alpha3code: "TTO",
  },
  {
    name: "Tunisia",
    phoneCode: "+216",
    alpha2code: "TN",
    alpha3code: "TUN",
  },
  {
    name: "Turkey",
    phoneCode: "+90",
    alpha2code: "TR",
    alpha3code: "TUR",
  },
  {
    name: "Turkmenistan",
    phoneCode: "+993",
    alpha2code: "TM",
    alpha3code: "TKM",
  },
  {
    name: "Turks and Caicos Islands",
    phoneCode: "+1",
    alpha2code: "TC",
    alpha3code: "TCA",
  },
  {
    name: "Tuvalu",
    phoneCode: "+688",
    alpha2code: "TV",
    alpha3code: "TUV",
  },
  {
    name: "Uganda",
    phoneCode: "+256",
    alpha2code: "UG",
    alpha3code: "UGA",
  },
  {
    name: "Ukraine",
    phoneCode: "+380",
    alpha2code: "UA",
    alpha3code: "UKR",
  },
  {
    name: "United Arab Emirates",
    phoneCode: "+971",
    alpha2code: "AE",
    alpha3code: "ARE",
  },
  {
    name: "United Kingdom",
    phoneCode: "+44",
    alpha2code: "GB",
    alpha3code: "GBR",
  },
  {
    name: "United States",
    phoneCode: "+1",
    alpha2code: "US",
    alpha3code: "USA",
  },
  {
    name: "Uruguay",
    phoneCode: "+598",
    alpha2code: "UY",
    alpha3code: "URY",
  },
  {
    name: "U.S. Virgin Islands",
    phoneCode: "+1",
    alpha2code: "VI",
    alpha3code: "VIR",
  },
  {
    name: "Uzbekistan",
    phoneCode: "+998",
    alpha2code: "UZ",
    alpha3code: "UZB",
  },
  {
    name: "Vanuatu",
    phoneCode: "+678",
    alpha2code: "VU",
    alpha3code: "VUT",
  },
  {
    name: "Vatican City",
    phoneCode: "+39",
    alpha2code: "VA",
    alpha3code: "VAT",
  },
  {
    name: "Venezuela",
    phoneCode: "+58",
    alpha2code: "VE",
    alpha3code: "VEN",
  },
  {
    name: "Vietnam",
    phoneCode: "+84",
    alpha2code: "VN",
    alpha3code: "VNM",
  },
  {
    name: "Wallis and Futuna",
    phoneCode: "+681",
    alpha2code: "WF",
    alpha3code: "WLF",
  },
  {
    name: "Yemen",
    phoneCode: "+967",
    alpha2code: "YE",
    alpha3code: "YEM",
  },
  {
    name: "Zambia",
    phoneCode: "+260",
    alpha2code: "ZM",
    alpha3code: "ZMB",
  },
  {
    name: "Zimbabwe",
    phoneCode: "+263",
    alpha2code: "ZW",
    alpha3code: "ZWE",
  },
];


export const playsTableHeads = [
  { title: "COMPANY", orderBy: "company", sortBy: "sonicKey.company.name", isAscending: null, isActive: false },
  { title: "COMPANY TYPE", orderBy: "companyType", sortBy: "sonicKey.company.companyType", isAscending: null, isActive: false },
  { title: "ARTIST", orderBy: "artist", sortBy: "sonicKey.contentOwner", isAscending: null, isActive: false },
  { title: "TITLE", orderBy: "title", sortBy: "sonicKey.contentName", isAscending: null, isActive: false },
  { title: "RADIO STATION", orderBy: "radioStation", sortBy: "radioStation.name", isAscending: null, isActive: false },
  { title: "DATE", orderBy: "date", sortBy: "detectedAt", isAscending: null, isActive: false },
  { title: "TIME", orderBy: "time", sortBy: "detectedAt", isAscending: null, isActive: false },
  { title: "DURATION", orderBy: "duration", sortBy: "sonicKey.contentDuration", isAscending: null, isActive: false },
  { title: "COUNTRY", orderBy: "country", sortBy: "radioStation.country", isAscending: null, isActive: false },
  { title: "TRACK ID", orderBy: "trackId", sortBy: "sonicKey.track", isAscending: null, isActive: false },
  { title: "SONICKEY", orderBy: "sonicKey", sortBy: "sonicKey.sonicKey", isAscending: null, isActive: false },
  { title: "SK/SID", orderBy: "", sortBy: "", isAscending: null, isActive: false },
  { title: "VERSION", orderBy: "version", sortBy: "sonicKey.version", isAscending: null, isActive: false },
  { title: "DISTRIBUTOR", orderBy: "distributor", sortBy: "sonicKey.distributor", isAscending: null, isActive: false },
  { title: "LABEL", orderBy: "label", sortBy: "sonicKey.label", isAscending: null, isActive: false },
  { title: "ISRC", orderBy: "isrcCode", sortBy: "sonicKey.isrcCode", isAscending: null, isActive: false },
  { title: "ISWC", orderBy: "iswc", sortBy: "sonicKey.iswcCode", isAscending: null, isActive: false },
  { title: "TUNE CODE", orderBy: "tuneCode", sortBy: "sonicKey.tuneCode", isAscending: null, isActive: false },
  { title: "DESCRIPTION", orderBy: "", sortBy: "", isAscending: null, isActive: false },
  { title: "FILE TYPE", orderBy: "contentType", sortBy: "sonicKey.contentType", isAscending: null, isActive: false },
  { title: "ACTION", orderBy: "", sortBy: "", isAscending: null, isActive: false },
]

export const streamReaderTableHeads = [
  { title: "ID" },
  { title: "LOGO" },
  { title: "RADIO NAME" },
  { title: "RADIO URL" },
  { title: "ADDED DATE" },
  { title: "PLAYS" },
  { title: "STATUS" },
  { title: "ACTION" },
];

export const sonicStreamDetailsTableHeads = [
  { title: "ID" },
  { title: "SONICKEY" },
  { title: "NAME" },
  { title: "ARTIST" },
  { title: "QUALITY" },
  { title: "DESCRIPTION" },
  { title: "PLAYS" },
]

export const trackTableHeads = [
  { title: "TITLE", sortBy: "trackName", isAscending: null, isActive: false },
  { title: "PLAYS", sortBy: "playsCount", isAscending: null, isActive: false },
  { title: "RADIO STATION", sortBy: "radioStationCount", isAscending: null, isActive: false },
  { title: "COUNTRY", sortBy: "countriesCount", isAscending: null, isActive: false },
]

export const radioStationTableHeads = [
  { title: "RADIO STATION", sortBy: "radioStation.name", isAscending: null, isActive: false },
  { title: "COUNTRY", sortBy: "radioStation.country", isAscending: null, isActive: false },
  { title: "PLAYS", sortBy: "playsCount", isAscending: null, isActive: false },
  { title: "TRACKS", sortBy: "uniquePlaysCount", isAscending: null, isActive: false },
  { title: "ARTIST", sortBy: "artistsCount", isAscending: null, isActive: false },
]

export const artistTableHeads = [
  { title: "ARTIST NAME", sortBy: "artist", isAscending: null, isActive: false },
  { title: "PLAYS", sortBy: "playsCount", isAscending: null, isActive: false },
  { title: "TRACKS", sortBy: "uniquePlaysCount", isAscending: null, isActive: false },
  { title: "RADIO STATION", sortBy: "radioStationCount", isAscending: null, isActive: false },
  { title: "COUNTRIES", sortBy: "countriesCount", isAscending: null, isActive: false },
]

export const countryTableHeads = [
  { title: "COUNTRY", sortBy: "country", isAscending: null, isActive: false },
  { title: "PLAYS", sortBy: "playsCount", isAscending: null, isActive: false },
  { title: "TRACKS", sortBy: "uniquePlaysCount", isAscending: null, isActive: false },
  { title: "ARTISTS", sortBy: "artistsCount", isAscending: null, isActive: false },
  { title: "RADIO STATIONS", sortBy: "radioStationCount", isAscending: null, isActive: false },
]

export const monitorCompaniesTableHeads = [
  { title: "COMPANY", sortBy: "company.name", isAscending: null, isActive: false },
  { title: "COMPANY TYPE", sortBy: "company.companyType", isAscending: null, isActive: false },
  { title: "PLAYS", sortBy: "playsCount", isAscending: null, isActive: false },
  { title: "TRACKS", sortBy: "uniquePlaysCount", isAscending: null, isActive: false },
  { title: "ARTISTS", sortBy: "artistsCount", isAscending: null, isActive: false },
]

export const licenseTableHeads = [
  { title: "ACCOUNT NAME" },
  { title: "MAX USES ENCODE" },
  { title: "MAX USES MONITOR" },
  { title: "ACCOUNT TYPE" },
  { title: "USERS" },
  { title: "RENEWAL DATE" },
  { title: "LICENSE NAME" },
  { title: "KEY" },
  { title: "STATUS" },
  { title: "ACTION" },
]

export const usersTableHeads = [
  { title: "USERNAME" },
  { title: "USER ID" },
  { title: "EMAIL" },
  { title: "PHONE NUMBER" },
  { title: "ACCOUNT TYPE" },
  { title: "ACCOUNT NAME" },
  { title: "COMPANY NAME" },
  { title: "USER TYPE" },
  { title: "STATUS" },
  { title: "ACTION" },
]

export const companiesTableHeads = [
  { title: "COMPANY" },
  { title: "COMPANY TYPE" },
  { title: "COMPANY ID" },
  { title: "EMAIL" },
  { title: "PHONE NUMBER" },
  { title: "ADMIN" },
  { title: "STATUS" },
  { title: "ACTION" },
]

export const sonicKeyTableHeads = [
  { title: "TRACK ID" },
  { title: "SONICKEY" },
  { title: "TITLE" },
  { title: "VERSION" },
  { title: "ARTIST" },
  { title: "DISTRIBUTOR" },
  { title: "DESCRIPTION" },
  { title: "ENCODED DATE" },
  { title: "ACTION" },
]

export const tracksTableHeads = [
  { title: "TRACK ID", sortBy: "_id", isAscending: null, isActive: false },
  { title: "TITLE", sortBy: "trackMetaData.contentName", isAscending: null, isActive: false },
  { title: "VERSION", sortBy: "trackMetaData.version", isAscending: null, isActive: false },
  { title: "ARTIST", sortBy: "trackMetaData.contentOwner", isAscending: null, isActive: false },
  { title: "DISTRIBUTOR", sortBy: "trackMetaData.distributor", isAscending: null, isActive: false },
  // { title: "FILE TYPE", sortBy: "trackMetaData.contentFileType", isAscending: null, isActive: false },
  { title: "ENCODED DATE", sortBy: "createdAt", isAscending: null, isActive: false },
  { title: "SK COUNT", sortBy: "", isAscending: null, isActive: false },
  // { title: "SYSTEM/PARTNER ID", sortBy: "SYSTEM/PARTNER_ID", isAscending: null, isActive: false },
  { title: "ACTION", sortBy: "", isAscending: null, isActive: false },
]

export const encodesByCompanyTableHeads = [
  { title: "COMPANY", sortBy: "name", isAscending: null, isActive: false },
  { title: "ENCODES", sortBy: "encodesCount", isAscending: null, isActive: false }
]

//Dropdown values
export const channel = [
  { name: "ALL" },
  { name: "STREAMREADER" },
  { name: "PORTAL" },
  { name: "MOBILE" },
]

export const detectionOrigins = {
  SONICKEY: {
    name: "SONICKEY",
    shortName: "SK"
  },
  FINGERPRINT: {
    name: "FINGERPRINT",
    shortName: "SID"
  }
}

export const accountType = [
  { name: "Partner" },
  { name: "Company" },
]

export const licenseType = [
  { name: "Individual" },
  { name: "Company" },
]

export const status = [
  { name: "Active" },
  { name: "Suspended" },
]

export const userType = [
  { name: "Admin" },
  { name: "Standard" },
]

export const partnerTypes = [
  { name: 'CMO' },
  { name: 'Distributor' },
  { name: 'Monitoring Company' },
  { name: 'Music Management Services' },
  { name: 'PRO' },
  { name: 'Production Library' },
  { name: 'Publisher' },
  { name: 'Record Company' },
  { name: 'Sub Publisher' },
];

export const companyType = [
  { name: "Advertising" },
  { name: "Artist" },
  { name: "Artist Manager" },
  { name: "CMO (Collective Management Organisation)" },
  { name: "Composer" },
  { name: "Corporate" },
  { name: "Distributor" },
  { name: "DSP" },
  { name: "Film/TV" },
  { name: "Label" },
  { name: "Monitor" },
  { name: "Music Management Services" },
  { name: "PRO (Public Rights Organisation)" },
  { name: "Production Library" },
  { name: "Publisher" },
  { name: "Rights Holder" },
  { name: "Song Writer" },
  { name: "Sub Publisher" },
]

export const userRoles = {
  PORTAL_USER: "PortalUser",
  PARTNER_ADMIN: "PartnerAdmin",
  PARTNER_USER: "PartnerUser",
  COMPANY_ADMIN: "CompanyAdmin",
  COMPANY_USER: "CompanyUser"
}

export const Labels = [
  "1605",
  "1-2-3-4 Go! Records",
  "1017 Records",
  "12 Tónar",
  "12k",
  "13th Planet Records",
  "143 Records",
  "14th Floor Records",
  "16th Avenue Records",
  "19 Recordings",
  "1965 Records",
  "2 Tone Records",
  "20th Century Fox Records",
  "21st Circuitry",
  "24 Hour Service Station",
  "3 Beat Records",
  "300 Entertainment",
  "301Studios",
  "33rd Street Records",
  "3CG Records",
  "3D Vision Records",
  "4 Star Records",
  "415 Records",
  "430 West Records",
  "4AD",
  "4th & Broadway",
  "5 Minute Walk",
  "5 Rue Christine",
  "50 Records",
  "50 Skidillion Watts",
  "504 Records",
  "550 Music",
  "604 Records",
  "625 Thrashcore",
  "679 Artists",
  "75 Ark",
  "77 Records",
  "7th Magnitude",
  "88rising",
  "8bitpeoples",
  "960 Music Group",
  "99 Records",
  "A Cappella Records",
  "A Different Drum",
  "A Low Hum",
  "A-F Records",
  "A-Musik",
  "A&E Records",
  "A&M Records",
  "Abbey Records",
  "Abbott Records",
  "ABC Classics",
  "ABC Dunhill Records",
  "ABC Records",
  "ABC-Paramount Records",
  "Abco Records",
  "ABKCO Records",
  "Able Label",
  "Abnak Records",
  "Abner Records",
  "Absolutely Kosher Records",
  "Abstract Logix",
  "Abundant Life Ministries",
  "Accent Records",
  "Accent Records (US)",
  "Ace Fu Records",
  "Ace of Clubs Records",
  "Ace of Hearts Records",
  "Ace of Hearts Records (US)",
  "Ace Records (United Kingdom)",
  "Ace Records (United States)",
  "Ache Records",
  "Acid Jazz Records",
  "Aco Records",
  "Acorn Records",
  "Acoustic Disc",
  "Acte Préalable",
  "Ad Noiseam",
  "Adam VIII",
  "Adeline Records",
  "Adelphi Records",
  "Aditya Music",
  "Advent Records",
  "Aegean Records",
  "Aeronaut Records",
  "AFM Records",
  "AFO Records",
  "African Museum",
  "Aftermath Entertainment",
  "Aggro Berlin",
  "Agit-Prop Records",
  "Agitprop! Records",
  "Ahdasee Records",
  "AIP Records",
  "Airport Route Recordings",
  "Ajax Records",
  "Aladdin Records",
  "Alarma Records",
  "Albany Records",
  "Albert Productions",
  "Alchemy Records (Japan)",
  "Alchemy Records (U.S.)",
  "Alcopop! Records",
  "Alegre Records",
  "Alert Records",
  "Alfa Matrix",
  "Alfa Records",
  "Alias Records",
  "Alien8 Recordings",
  "Alive Records",
  "All Around the World",
  "All Ice Records",
  "All Platinum Records",
  "All Saints Records",
  "All Star Records",
  "All the Madmen Records",
  "Allalom Music",
  "Allido Records",
  "Alligator Records",
  "Almo Sounds",
  "Almost Gold Recordings",
  "Alpha Pup Records",
  "Alta Records",
  "Altarus Records",
  "Alternative Tentacles",
  "AM:PM Records",
  "Amalgam Digital",
  "Amarillo Records",
  "Amaru Entertainment",
  "Ambiances Magnétiques",
  "Ambitiouz Entertainment",
  "Ambush Reality Records",
  "American Gramaphone",
  "American King Music",
  "American Modern Recordings",
  "American Music Records",
  "American Record Company",
  "American Record Corporation",
  "American Recording Productions",
  "American Recordings (US)",
  "Amha Records",
  "Amiga",
  "Ammor Records",
  "Amos Records",
  "Ampex Records",
  "Amphetamine Reptile Records",
  "Amplexus",
  "Amusic",
  "Amy Records",
  "Analekta",
  "Anchor Records",
  "And/oar",
  "Andie Records",
  "Andmoresound",
  "Angel Air Records",
  "Angel Records",
  "Angelophone Records",
  "Angular Recording Corporation",
  "Anhrefn Records",
  "AnimeTrax",
  "Aniplex",
  "Anjunabeats",
  "Ankst",
  "Ankstmusik",
  "Anna Records",
  "Annette Records",
  "Another Century Records",
  "Anova Music",
  "Anthem Records",
  "ANTI-",
  "Anti-Creative Records",
  "Anticon Records",
  "Antilles Records",
  "Antone's Record Label",
  "Anxious Records",
  "Anyway Records",
  "Aozora Records",
  "Apegenine recordings",
  "Apex Records",
  "Aphonia Recordings",
  "Apollo Records (1921) (U.S.)",
  "Apollo Records (1928) (U.S.)",
  "Apollo Records (1944) (U.S.)",
  "Apollo Records (Belgium)",
  "Appian Publications & Recordings",
  "Applause Records",
  "Apple Records",
  "April/Schneeball",
  "Apt Records",
  "Aquarius Records (Canada)",
  "Aquarius Records (Croatia)",
  "Arabesque Records",
  "ARC Records",
  "Arch Hill Recordings",
  "Archenemy Record Company",
  "Archeophone Records",
  "Architecture Label",
  "Archive International Productions",
  "Arcola",
  "Ardent Records",
  "Arena Rock Recording Co.",
  "Aretino Records",
  "Argo Records (U.S.)",
  "Argo Records (UK)",
  "Arhoolie Records",
  "Ariola Records",
  "Arista Nashville",
  "Arista Records",
  "Aristocrat Records",
  "Ark 21 Records",
  "Armada Music",
  "Around Us Entertainment",
  "Artanis Entertainment Group",
  "ARTISTdirect",
  "Artistic Records",
  "Arto Records",
  "Artoffact Records",
  "Arts & Crafts",
  "Asbestos Records",
  "Aesop Label",
  "Ash International",
  "Asian Man Records",
  "Asphodel Records",
  "Asthmatic Kitty Records",
  "Astralwerks",
  "Astro Magnetics",
  "ASV Records",
  "Asylum Records",
  "Atavistic Records",
  "Atco Records",
  "ATIC Records",
  "Atlantic Jaxx",
  "Atlantic Records",
  "ATO Records",
  "Atoll Records",
  "ATP Recordings",
  "Attack Records (UK)",
  "Attic Records (Canada)",
  "Attitude Records",
  "Atypeek Music",
  "Au Go Go Records",
  "Audio Antihero",
  "Audio Dregs",
  "Audio Fidelity Records",
  "Audio Therapy",
  "Audiogram",
  "Audiophile Records",
  "Audition Records",
  "Aum Fidelity",
  "Authentic Records",
  "Autograph Records",
  "Autumn Records",
  "AVA Recordings",
  "Avang Music",
  "Avantgarde Music",
  "Avatar Records",
  "Avatar Records (Electronic)",
  "Avco Records",
  "Avex Trax",
  "AVI Records",
  "Aviance Records",
  "Aware Records",
  "Awareness Records",
  "Azteca Records",
  "Azuli Records",
  "B-Boy Records",
  "B-Unique Records",
  "B.O.S.S.",
  "Babel Label",
  "Baby Records (Italian label)",
  "Babygrande Records",
  "Back Beat Records",
  "Backporch Revolution",
  "Bad Boy Records",
  "Bad Taste",
  "Bad Taste Records",
  "Badorb.com",
  "Balkan Samba Records",
  "Balkanton",
  "Bally Records",
  "Banda Records",
  "Bang Records",
  "Bangor Records",
  "Banner Records",
  "Bar/None Records",
  "Baratos Afins",
  "Barclay Records",
  "Barely Breaking Even",
  "Barking Hoop Recordings",
  "Barking Pumpkin Records",
  "Barn Records",
  "Barnaby Records",
  "Barrelhouse Records",
  "Barsuk Records",
  "Basic Beat Recordings",
  "Basic Replay",
  "Basick Records",
  "Bassivity Music",
  "Baton Records",
  "Bayou Teche Brewery",
  "BBC Radio Collection",
  "BBC Records",
  "BBR Music Group",
  "BC Recordings",
  "BCore Disc",
  "Bear Family Records",
  "Bearsville Records",
  "Beat Factory",
  "Beatservice Records",
  "BEC Recordings",
  "Bedazzled Records",
  "Bedrock Records",
  "Bedroom Community",
  "Beggars Banquet Records",
  "Beka Records",
  "Bel-Tone Records",
  "Bell Records (1920s) (U.S.)",
  "Bell Records (1940) (U.S.)",
  "Bell Records (U.S. and U.K.)",
  "Bella Union",
  "Bellaccord",
  "Bellmark Records",
  "Below Par Records",
  "Beltona Records",
  "Beluga Heights Records",
  "Belvedere Records",
  "Benbecula Records",
  "Benson Records",
  "Berlee Records",
  "Berliner Gramophone",
  "Beserkley Records",
  "Bet-Car Records",
  "Beta-lactam Ring Records",
  "Bethlehem Records",
  "Better Looking Records",
  "Beverley's",
  "Beyond Records (Norway) (2011)",
  "Beyond Records (U.K. 1992)",
  "Beyond Therapy Records",
  "BI'N Music",
  "Bibletone Records",
  "Biddulph Recordings",
  "Bieler Bros. Records",
  "Big Bear Records",
  "Big Beat Records (Ace subsidiary)",
  "Big Beat Records (Atlantic subsidiary)",
  "Big Brother Recordings",
  "Big Cat Records",
  "Big Dada",
  "Big Hit Entertainment",
  "Big Hit Music",
  "Big Life",
  "Big Machine Records",
  "Big Neck Records",
  "Big Orange Clown Records",
  "Big Records",
  "Big Rig Records",
  "Big Scary Monsters Recording Company",
  "Big Time Records",
  "Big Top Records",
  "Big Tree Records",
  "Big Up Entertainment",
  "Big Vin Records",
  "Big Wheel Recreation",
  "Bigtop Records",
  "Biltmore Records",
  "Binge Records",
  "Bingola Records",
  "Biograph Records",
  "Birdman Records",
  "BIS Records",
  "Biscoito Fino",
  "bitbird",
  "Biv 10 Records",
  "Bizarre Records",
  "Black & White Records",
  "Black Acre",
  "Black and Greene Records",
  "Black Butter Records",
  "Black Hen Music",
  "Black Hole Recordings",
  "Black Jays",
  "Black Kapital Records",
  "Black Mark Production",
  "Black Market Activities",
  "Black Patti Records",
  "Black Pill Red Pill",
  "Black Saint/Soul Note",
  "Black Swan Records",
  "Black Swan Records (UK)",
  "Black Top Records",
  "Blackened Recordings",
  "Blackground Records",
  "Blackhouse Records",
  "Blackout Records",
  "Blacksmith Records",
  "Blast First",
  "BLIGHT. Records",
  "Block Entertainment",
  "Block Starz Music",
  "Blocks Recording Club",
  "Blonde Vinyl",
  "Blood and Fire",
  "Blood and Ink Records",
  "Bloodline Records",
  "Bloodshot Records",
  "Bloodwork Records",
  "Bloody Fist Records",
  "Blue Amberol Records",
  "Blue Beat Records",
  "Blue Cat Records",
  "Blue Dog Records",
  "Blue Goose Records",
  "Blue Horizon",
  "Blue Jordan Records",
  "Blue Lake Records",
  "Blue Note Records",
  "Blue Rock Records",
  "Blue Room Released",
  "Blue Swan Records",
  "Blue Thumb Records",
  "Bluebird Records",
  "Blues Beacon Records",
  "BlueSanct Records",
  "Bluesville Records",
  "Bluesway Records",
  "BME Recordings",
  "BMG",
  "BMG Heritage Records",
  "BMG Music Canada",
  "BMG Rights Management",
  "BNA Records",
  "Boardwalk Records",
  "Body Head Entertainment",
  "Bomp! Records",
  "Boner Records",
  "Bong Load Custom Records",
  "Bonnier Amigo Music Group",
  "Bonnier Gazell Music",
  "Bonsound Records",
  "Bonzai Records",
  "Boompa Records",
  "Boomtown Records",
  "Bop Cassettes",
  "Borderline Records",
  "Boy Better Know",
  "BPitch Control",
  "Bradley's Records",
  "Brainfeeder",
  "Brass Tacks Records",
  "Brassland Records",
  "Brave Wave Productions",
  "Breakbeat Kaos",
  "Breastfed Recordings",
  "Breezeway Records",
  "Brick Squad Monopoly",
  "Bridge 9 Records",
  "Bridge Records, Inc.",
  "Bright Antenna",
  "Brille Records",
  "Broadcast Twelve Records",
  "Broadmoor Records",
  "Broadway Records (1920s)",
  "Broadway Records (1947)",
  "Broadway Records (2012)",
  "Broken Records",
  "Broken Spoke Records",
  "Bronze Records",
  "Bros Records",
  "Brother Records",
  "Bruc Records",
  "Brunswick Records",
  "Brushfire Records",
  "Brutal Panda Records",
  "Brute/Beaute Records",
  "BSD Records",
  "BTNH Worldwide",
  "Buddah Records",
  "Buddyhead Records",
  "Buena Vista Music Group",
  "Bulb Records",
  "Bullet Records",
  "Bumstead Records",
  "Bungalo Records",
  "Bureau B",
  "Burger Records",
  "Burgundy Records",
  "Burning Heart Records",
  "Burnt Toast Vinyl",
  "Business Deal Records",
  "Busted Flat Records",
  "Busy Bee",
  "Butterfly Recordings",
  "BYG Actuel",
  "BYO Records",
  "C.I.A. Records",
  "C/Z Records",
  "C4 Records",
  "Cactus Jack Records",
  "Cadence Jazz Records",
  "Cadence Records",
  "Cadet Records",
  "Caedmon Audio",
  "Caff Records",
  "Calabash Music",
  "Caldo Verde Records",
  "CAM (Italy)",
  "CAM Entertainment (Japan)",
  "Camcor Records",
  "Cameo Records",
  "Cameo-Kid",
  "Cameo-Parkway Records",
  "Camino Records",
  "Camp Records",
  "Canaan Records",
  "Canadian-American Records",
  "Candid Records",
  "Candle Records",
  "Candlelight Records",
  "Candy Ass Records",
  "CandyRat Records",
  "Cantaloupe Music",
  "Cantora Records",
  "Capitol Hill Music",
  "Capitol Music Group",
  "Capitol Records",
  "Capricorn Records",
  "Captain Oi! Records",
  "Captains of Industry",
  "Caravan of Dreams Productions",
  "Carbon Copy Media",
  "Cardinal Records (1920s) (U.S.)",
  "Cardinal Records (1950s) (U.S.)",
  "Cardinal Records (1964) (Belgium)",
  "Cargo Music",
  "Cargo Records (Canada)",
  "Cargo Records (UK)",
  "Caribou Records",
  "Carish",
  "Carl Lindström Company",
  "Carnival Records",
  "Caroline Distribution",
  "Caroline Records (U.S. and U.K.)",
  "Carpark Records",
  "Carrillo Music",
  "Casablanca Records",
  "Cash Money Records",
  "Castle Communications",
  "Castle Records (Oregon)",
  "Catbird Records",
  "Catfish Records",
  "Cause 4 Concern Recordings",
  "Caustic Eye Productions",
  "Cavalier Records",
  "Cavetone Records",
  "Cavity Search Records",
  "CBC Records",
  "CBS Masterworks Records",
  "CBS Records",
  "Cedille Records",
  "Celestial Recordings",
  "Celluloid Records",
  "Celtic Music",
  "Celtophile Records",
  "Centaur Records",
  "Centricity Music",
  "Century Media Records",
  "Century Records",
  "Chainsaw Records",
  "Chalfont Records",
  "Chalice",
  "Challenge Records (1920s) (U.S.)",
  "Challenge Records (1950s) (U.S.)",
  "Challenge Records (1994) (Netherlands)",
  "Chameleon",
  "Chamillitary",
  "Chamillitary Entertainment",
  "Champion Records (Nashville, Tennessee)",
  "Champion Records (Richmond, Indiana)",
  "Champion Records (UK)",
  "Chance Records",
  "Chancellor Records",
  "Chandos Records",
  "Channel Classics Records",
  "Chapel Records",
  "Chappelle and Stinnette Records",
  "Chapter Music",
  "Charged Records",
  "Charisma Records",
  "Charly Records",
  "Chart Records",
  "Ché Trading",
  "Cheap Records",
  "Checker Records",
  "Cheeky Records",
  "Cheetah Records",
  "Chelsea Records",
  "Chemikal Underground",
  "Cherry Red",
  "CherryDisc Records",
  "Cherrytree Records",
  "Chesky Records",
  "Chess Records",
  "Chi Sound Records",
  "Chichūkai Label",
  "Chief Records",
  "Chimney Sweep Records",
  "China Record Corporation",
  "China Records",
  "Chiswick Records",
  "Chocolate City Music",
  "Chocolate Frog Records",
  "Chopper City Records",
  "Christian Faith Recordings",
  "Chrysalis Records",
  "Chunksaah Records",
  "CI Records",
  "Cinepoly Records",
  "Cinevox",
  "Cinnamon Toast Records",
  "Circle Records",
  "City Centre Offices",
  "City Slang Records",
  "Claddagh Records",
  "Classic Produktion Osnabrück",
  "Classics Club",
  "Claves Records",
  "Clay Records",
  "Clean Feed Records",
  "Clean-up Records",
  "Cleopatra Records",
  "Cleveland International Records",
  "Clickpop Records",
  "CLJ Records",
  "Cloud Recordings",
  "Clover Records",
  "CLS Records",
  "Clubbo Records",
  "CMC International",
  "Cobra Records",
  "Cock Rock Disco",
  "Coconut Records",
  "Cocoon Recordings",
  "Codiscos",
  "Coed Records",
  "Cold Chillin' Records",
  "Cold Chillin’ Records",
  "Cold Meat Industry",
  "Cold Spring",
  "Colgems Records",
  "Collectables Records",
  "Collector Records",
  "Collins Classics",
  "Colonial Records",
  "Colortone Records",
  "Colpix Records",
  "Columbia Graphophone Company",
  "Columbia Masterworks Records",
  "Columbia Music Entertainment",
  "Columbia Records",
  "Combat Records",
  "Come Organisation",
  "Comedy Central Records",
  "Command Performance Records",
  "Command Records",
  "Commodore Records",
  "Compadre Records",
  "Compass Records",
  "Composers Recordings, Inc.",
  "Compost Records",
  "Concert Artist Recordings",
  "Concord Music Group",
  "Concord Records",
  "Connoisseur Society",
  "Conqueror Records",
  "Conspiracy Music",
  "Constantinople Records",
  "Constellation Records (disambiguation)",
  "Contemode",
  "Contemporary Records",
  "Continental Records",
  "Cook Records",
  "Cooking Vinyl",
  "Cooltempo Records",
  "Copenhagen Records",
  "Copper Creek Records",
  "Coral Records",
  "Cordless Recordings",
  "Cornerstone RAS",
  "Corona Records",
  "Coronet Records",
  "Corporate Punishment Records",
  "Corpus Christi Records",
  "Corwood Industries",
  "Cotillion Records",
  "Country Turtle Records",
  "Cowboy Records",
  "CP Records",
  "Crammed Discs",
  "Crank! Records",
  "Crass Records",
  "Crave Records",
  "CRD Records",
  "Cream Records",
  "Creation Records",
  "Creative Vibes",
  "Credential Recordings",
  "Creeping Bent",
  "Creole Records",
  "Crescent Records",
  "Cricket Records",
  "Criminal IQ Records",
  "Crimson Records",
  "Croatia Records",
  "Cross Movement Records",
  "Crown Records",
  "Crunchy Frog Records",
  "Crustacean Records",
  "Cruz Records",
  "Crydamoure",
  "Crying Sun Records",
  "Crypt Records",
  "Cryptogramophone Records",
  "CTI Records",
  "Cub Records",
  "Cube Entertainment",
  "Cube Records",
  "Cuca Records",
  "Cult Records",
  "Culture Press",
  "Cumberland Records",
  "Cuneiform Records",
  "Curb Records",
  "Curling Legs",
  "Curtom Records",
  "Curves Music",
  "Custard Records",
  "Cutting Edge",
  "Cybele Records",
  "Cypress Records",
  "Czar Entertainment",
  "Czyz Records",
  "D Records",
  "D-Block Records",
  "D-Town Music Group, Inc.",
  "D.P.G. Recordz",
  "Da Lench Mob Records",
  "Daemon Records",
  "Daesung Entertainment",
  "Daffodil Records",
  "Dais Records",
  "Dallas Records",
  "Damaged Goods",
  "Dame Dash Music Group",
  "Damnably",
  "Damon Records",
  "Dana Records",
  "Dance Mania",
  "Dance to the Radio",
  "Dancing Cat Records",
  "Dancing Ferret",
  "Dandelion Records",
  "Danger Crue Records",
  "Dangerbird Records",
  "Dangerhouse Records",
  "Danse Macabre Records",
  "Daptone Records",
  "Dare to Care Records",
  "Dark Horse Records",
  "Darkest Labyrinth",
  "Darla Records",
  "Data Records",
  "Dawn Raid Entertainment",
  "Dawn Records",
  "Daylight Records",
  "DaySpring Records",
  "DB Records",
  "DC Flag Records",
  "DC-Jam Records",
  "DCide",
  "De Luxe Records",
  "De Werf",
  "De Wolfe Music",
  "Dead Oceans Records",
  "Dead Reckoning Records",
  "Deaf Records",
  "Death Row Records",
  "Deathlike Silence Productions",
  "Deathwish Inc.",
  "Debut Records",
  "Decaydance Records",
  "Decca Records",
  "Deceptive Records",
  "Decon Records",
  "Deconstruction Records",
  "Deep Elm Records",
  "Deep Shag Records",
  "Deep Soul Records",
  "Def American",
  "Def Jam Records",
  "Def Jam South",
  "Defected Records",
  "Defiance Records",
  "Definitive Jux",
  "Defstar Records",
  "Dekema Records",
  "Del-Fi Records",
  "Delerium Records",
  "Delicious Vinyl",
  "Delirium Records",
  "Delmark Records",
  "Delphine Records",
  "Deltasonic",
  "Deluxe Records",
  "Demon Records",
  "Dental Records",
  "Dented Records",
  "Dependent Music",
  "Dependent Records",
  "Deptford Fun City Records",
  "Deram Records",
  "Derby Records",
  "Derrty Entertainment",
  "Desert Storm",
  "DeSoto Records",
  "Desperation Records",
  "Desto Records",
  "Deutsche Grammophon",
  "Deviant Records",
  "Dew Process",
  "Dewdrops Records",
  "DF Music Organization",
  "DFA Records",
  "DFTBA Records",
  "DGC Records",
  "Dial Records (1946) (U.S.)",
  "Dial Records (1964) (U.S.)",
  "Dial Records (1998) (U.S.)",
  "Dial Records (1999) (Germany)",
  "Diamante Music Group",
  "Diamond Cut Productions",
  "Diamond Records",
  "Dice Records (1950/60's NY label)",
  "Dick Bros Record Company",
  "Diffusion Records",
  "Digital Hardcore Recordings",
  "DigSin",
  "Dim Mak Records",
  "Dimension Records",
  "Din Of Ecstasy Records",
  "Dine Alone Records",
  "Dino Entertainment",
  "Diplomat Records",
  "Diplomat Records (budget)",
  "Dirtnap Records",
  "Dirty Hit",
  "Dirty Records",
  "Dirtybird Records",
  "Disa Records",
  "Dischord Records",
  "Discipline Global Mobile",
  "Discodance",
  "Discos Fuentes",
  "Discos Taxco",
  "Discos y Cintas Denver",
  "Discovery Records",
  "DiscReet Records",
  "Diskos",
  "Diskoton",
  "Disneyland Records",
  "Disorient Records",
  "Displeased Records",
  "Disques Dreyfus",
  "Disques Victoire",
  "Disques Vogue",
  "Distiller Records",
  "Distinct'ive Breaks Records",
  "Distinct'ive Records",
  "Distort Entertainment",
  "Distribution Select",
  "Disturbing tha Peace",
  "Diva Records",
  "DIW Records",
  "Dixieland Jubilee Records",
  "DJM Records",
  "Do It Records",
  "Dream Catalogue",
  "Doctor Dream Records",
  "Document Records",
  "Dog Meat Records",
  "Doggystyle Records",
  "Dolores Recordings",
  "Dolphin Music",
  "Dolton Records",
  "Domino Recording Company (1993)",
  "Domino Records (1916–1917)",
  "Domino Records (1924–1934)",
  "Domino Records (1957–1961)",
  "Domo Records",
  "Don Giovanni Records",
  "Doomtree",
  "Dope House Records",
  "Doré Records",
  "Dot Dash Recordings",
  "Dot Records",
  "Double Zero Records",
  "Double-Time Records",
  "Doublemoon",
  "Dovecote Records",
  "Downtown Records",
  "Drag City",
  "Dragon Mob Records",
  "Dragon Records",
  "Dragon Street Records",
  "Drakkar Entertainment",
  "Drama Records",
  "Dramatico",
  "Draper Inc. Records",
  "Dream Chasers Records",
  "Dreamboat Records",
  "Dreamville Records",
  "DreamWorks Records",
  "Drive-Thru Records",
  "Driven Music Group",
  "Dro Records",
  "DROG Records",
  "DRT Entertainment",
  "Drumcode Records",
  "DSFA Records",
  "DSN Music",
  "Dualtone Records",
  "Duck Down Records",
  "Duck Records",
  "Ductape Records",
  "Duke Records",
  "Duke Street Records",
  "Duna Records",
  "Dunhill Records",
  "Dunk Yer Funk Records",
  "Dunwich Records",
  "Duophonic Records",
  "Durium Records",
  "DVS Records",
  "Dynamic",
  "Dynamica",
  "DynoVoice Records",
  "E.G. Records",
  "E1 Music",
  "Eagle Records",
  "Eagle Rock Entertainment",
  "Eagle Rock Records",
  "Earache Records",
  "Eardrum Records",
  "Early Records",
  "Earthly Delights",
  "Earwig Music Company",
  "East Meets West Music",
  "East Side Digital Records",
  "East West Records",
  "Eastern Conference Records",
  "Eastlawn Records",
  "EatUrMusic",
  "EBUL",
  "Echo Records",
  "Eclipse Records",
  "ECM",
  "Ecstatic Peace!",
  "Ecstatic Yod",
  "Ed Banger Records",
  "Edel Music",
  "Edel-Mega Records",
  "Edelweiss Emission",
  "Edison Bell",
  "Edison Records",
  "Edition Lilac",
  "Eenie Meenie Records",
  "Eerie Materials",
  "EFM Records",
  "EG Records",
  "EggHunt Records",
  "EGREM",
  "Eibon Records",
  "Ektaar Music Ltd",
  "El Cartel Records",
  "El Puerto Records",
  "Élan Recordings",
  "Electrecord",
  "Electric Honey",
  "Electrola",
  "Elefant Records",
  "Elefant Traks",
  "Elektra Records",
  "Element 9",
  "Elementree Records",
  "Elenco",
  "Eleven Seven Music",
  "Eleven: A Music Company",
  "eleveneleven",
  "Ellahy Amen Records",
  "Elypsia Records",
  "Em:t Records",
  "Emanem Records",
  "EmArcy Records",
  "Embassy Records",
  "Embryo Records",
  "Emerald Music",
  "Emerald Records (1966)",
  "Emerald Records (2000s)",
  "Emergency Broadcast System Records",
  "Emergency Records",
  "Emerson Records",
  "EMI",
  "EMI America Records",
  "EMI Christian Music Group",
  "EMI Classics",
  "EMI Hemisphere",
  "EMI Latin",
  "EMI Records",
  "EMI-Capitol Special Markets",
  "Emotive Sounds",
  "Emperor Jones",
  "Emperor Norton Records",
  "Empire Mates Entertainment",
  "empreintes DIGITALes",
  "End All Life Productions",
  "End Records",
  "Endearing Records",
  "Energy Rekords",
  "Enigma Records",
  "Enjoy Records",
  "Ensign Records",
  "Enterprise Records",
  "Entertainment One Music",
  "Enzyme Records",
  "Epic Records",
  "Epidemic Records",
  "Epitaph Records",
  "Equal Vision Records",
  "Equator Records (Canada)",
  "Equator Records (Kenya)",
  "Equity Music Group",
  "Era Records",
  "Erased Tapes Records",
  "Erato Records",
  "Eros Music",
  "Ersatz Audio",
  "Ersguterjunge",
  "Erstwhile Records",
  "Eskaton",
  "ESL Music",
  "ESP-Disk",
  "Esquimaux Management",
  "Esquire Records",
  "Esquire Records (UK)",
  "Essential Records (Christian)",
  "Essential Records (London)",
  "Essex Records",
  "Estonian Record Productions",
  "Estrus Records",
  "Esurient Communications",
  "Eternal Records",
  "Eulogy Recordings",
  "Eurodisc",
  "Europa",
  "Ever Reviled Records",
  "Everest Records",
  "Everloving Records",
  "Excel Records",
  "Excello Records",
  "Excelsior Recordings",
  "Exceptional Records",
  "Executive Music Group",
  "EXERCISE1 Records",
  "Exit Records",
  "Exodus Records",
  "Exploding in Sound",
  "Extasy Records",
  "Extensive Music",
  "Extreme Records",
  "Eye Q",
  "Eyeball Records",
  "F-Beat Records",
  "F-IRE Collective",
  "F.A.M ENT",
  "Facedown Records",
  "Factory Records",
  "Fade To Mind",
  "Fader Label",
  "Failsafe Records",
  "Falcon Records - subsidiary of Vee-Jay",
  "Falcon Records (Canadian label)",
  "Falcon Records (Texas)",
  "Fall of the West Records",
  "Falling A Records",
  "Family Tree Records",
  "Famous Records",
  "Fanfare Records",
  "Fania Records",
  "Fantastic Plastic Records",
  "Fantasy Records",
  "Fascination Records",
  "Fast Product",
  "Fat Cat Records",
  "Fat Possum Records",
  "Fat Wreck Chords",
  "Fatal Recordings",
  "Father/Daughter Records",
  "Faultline Records",
  "Favored Nations",
  "FAX +49-69/450464",
  "FCommunications",
  "Fearless Records",
  "Federal Records",
  "Fellside Records",
  "Felsted Records UK",
  "Fence Records",
  "Fenway Recordings",
  "Ferret Music",
  "Fervent Records",
  "Fervor Records",
  "Festival Distribution",
  "Festival Records",
  "Fever Records",
  "Fflach",
  "FFRR Records",
  "Fiction Records",
  "Fiddler Records",
  "Fidelity Records",
  "Fierce Angel",
  "Fierce Panda Records",
  "Fifth Colvmn Records",
  "Figure IV Entertainment",
  "Film Score Monthly",
  "FILMguerrero",
  "Filthy Note",
  "Filtro Musik",
  "Finger Lickin' Records",
  "Fingerprint Records",
  "Fire Records (Pakistan)",
  "Fire Records (U.S.)",
  "Fire Records (UK)",
  "Firebox Records",
  "First Avenue Records",
  "First Priority Music",
  "First Terrace Records",
  "Fitamin Un",
  "FiXT Music",
  "Flair Records",
  "Flameshovel Records",
  "Flamingo Recordings",
  "Flashover Recordings",
  "Flashpoint Music",
  "Flawless Records",
  "Fledg'ling Records",
  "Flemish Eye",
  "Flicker Records",
  "Flip Records (1950s)",
  "Flip Records (1994)",
  "Flipmode Entertainment",
  "Fly Records",
  "Flying Fish Records",
  "Flying Nun Records",
  "Flying Tart",
  "Flyright Records",
  "Flyte Tyme Records",
  "FM Records",
  "FMP (Free Music Production)",
  "FMR Records",
  "Focus Group Holdings Limited",
  "Fog City Records",
  "Fogarty's Cove Music",
  "Folk-Legacy Records",
  "Folkways Records",
  "Fonal Records",
  "Fondle 'Em Records",
  "Fonotipia Records",
  "Fonovisa Records",
  "Fontana Records",
  "Food Records",
  "Fool's Gold Records",
  "Fools of the World",
  "Forced Exposure",
  "Forces of Satan Records",
  "ForeFront Records",
  "Foreshadow",
  "Formation Records",
  "Fort Knocks Entertainment",
  "Fortissimo Records",
  "Fortuna Pop!",
  "Fortune Records",
  "Forward Motion Records",
  "Four Music",
  "Fourth And Broadway Records",
  "Fourth Dimension Records",
  "Fowl Records",
  "Fox Music",
  "Fractured Transmitter Recording Company",
  "Fraternity Records",
  "FRE Records",
  "Freak Recordings",
  "Freakdance Records",
  "Fred Records",
  "Free Dirt Records",
  "Free-Will",
  "Freebandz",
  "Freedom From",
  "Freedom Records",
  "Freeworld Entertainment",
  "Frenchkiss Records",
  "Fresh Records (UK)",
  "Fresh Records (US)",
  "Friday Lights Music",
  "Friendly Fire Recordings",
  "Friendly Folk Records",
  "Frills GmbH",
  "Fringe Product",
  "Frog Pad Records",
  "Frog Records",
  "Frontier Records",
  "Frontiers Records",
  "Frontline Records (1980s)",
  "FSUK Records",
  "Fuel 2000",
  "Fueled by Ramen",
  "Fueradeserie!",
  "Full Moon Productions",
  "Full Moon Records (US)",
  "Full Surface Records",
  "Full Time Hobby",
  "Fullsteam Records",
  "Funk Volume",
  "Funtrip Records",
  "Fury Records",
  "Fusion Records",
  "Future Classic",
  "Future Farmer Records",
  "Future Records",
  "Fysisk Format",
  "G-Funk Entertainment",
  "G-Series",
  "G-Unit Records",
  "G*59 Records",
  "G7 Welcoming Committee Records",
  "Galaxy Records",
  "Galaxy21 Music",
  "Galilee of the Nations",
  "Galileo Records",
  "Gallo Record Company",
  "Gamble Records",
  "Gan-Shin",
  "Gangsta Advisory Records",
  "Gearhead Records",
  "Gee Records",
  "Gee Street Records",
  "Geffen Records",
  "Gekko Records",
  "General Records",
  "Genjing Records",
  "Gennett Records",
  "Geoma Records",
  "Gern Blandsten Records",
  "Get Low Recordz",
  "Ghetto Ruff",
  "Ghost Box Music",
  "Ghostlight Records",
  "Ghostly International",
  "Giant Electric Pea",
  "Giant Records",
  "Giant Step",
  "Giantslayer Records",
  "Gifted Records",
  "Gigantic Music",
  "Giorno Poetry Systems",
  "Giza Studio",
  "Glacial Pace",
  "Glasgow Underground Recordings",
  "Glitch Mode Recordings",
  "Glitterbeat Records",
  "Glitterhouse Records",
  "Global Music Group",
  "Global Trance Network",
  "Glowworm Records",
  "Glurp",
  "GMA Records",
  "GMM Grammy",
  "GMT Records",
  "Gnomonsong",
  "GNP Crescendo Records",
  "Go-Feet Records",
  "Go-Kart Records",
  "Go-Kustom Rekords",
  "Go! Beat Records",
  "Godzilla Entertainment",
  "Gold Castle Records",
  "Gold Label Records",
  "Gold Mind Records",
  "Gold Mountain Records",
  "Gold Robot Records",
  "Gold Standard Laboratories",
  "Gold Star Records",
  "Gold Typhoon",
  "Golden Era Records",
  "Golden World Records",
  "Goldenrod Records",
  "Goldwax Records",
  "Gone Records",
  "Goner Records",
  "Good Entertainment",
  "Good Hands Records",
  "Good Looking Records",
  "GOOD Music",
  "Good Records",
  "Good Time Jazz Records",
  "Good to Die Records",
  "Good Vibrations",
  "Gooom Disques",
  "Gordy Records",
  "GospoCentric Records",
  "Gotee Records",
  "Gourd Music",
  "Grafton Entertainment",
  "Gramavision Records",
  "Gramm",
  "Gramophone Company",
  "Granary Music",
  "Grand Award Records",
  "Grand Central Records",
  "Grand Hustle Records",
  "Grand Production",
  "Grand Royal",
  "Grapefruit",
  "Grappa Music",
  "Grateful Dead Records",
  "Graveface Records",
  "Gravitas Recordings",
  "Gravity Records",
  "Great Big Mouth Records",
  "Greedhead Music",
  "Green Cookie Records",
  "Green Linnet Records",
  "Greenhouse Music",
  "Greensleeves Records",
  "Greentrax Recordings",
  "Gregmark Records",
  "Grenadine Records",
  "Grey Gull Records",
  "Greyday Productions",
  "Griffin Music",
  "Gringo Records",
  "Groove Records",
  "GRP Records",
  "GRRR Records",
  "Grunt Records",
  "GTO Records",
  "Guerilla Records",
  "Guided Missile",
  "Guitarmonk Records",
  "Gulcher Records",
  "GUN Records",
  "Gusto Records",
  "Gut Records",
  "Gutterth",
  "Guy Cloutier Communications",
  "GWR Records",
  "H&L Records",
  "Hachama",
  "Hades Records",
  "Hakatak International",
  "Half A Cow",
  "Hallucination Recordings",
  "Hamburg Records",
  "Hamilton Records",
  "Hammock Music",
  "Hand Drawn Dracula",
  "Handsome Boy Records",
  "Hangars Liquides",
  "Hangman Records",
  "Hanna Barbera Records",
  "Hannibal Records",
  "Hansa Records",
  "Hanson Records",
  "Häpna",
  "Happy Couples Never Last",
  "Happy Happy Birthday To Me Records",
  "Happy Tiger Records",
  "HappySad Records",
  "Hardwood Records",
  "Harlekijn",
  "Harmolodics",
  "Harmonia Mundi",
  "Harmony Records",
  "Harriet Records",
  "Harthouse",
  "Harvest Records",
  "Hatchet House",
  "Hathut Records",
  "Headhunter Records",
  "Hear Music",
  "Heart Warming",
  "Heartbeat Records",
  "Heartbeat Records (Bristol)",
  "Hearts of Space Records",
  "Heaven Music",
  "Heaven Records",
  "Heavenly Records",
  "Hed Artzi Music",
  "Hed Kandi",
  "Hefty Records",
  "Heiress Records",
  "Heist Or Hit Records",
  "Helicon Records",
  "Hell, etc.",
  "Hellcat Records",
  "Hellhound Records",
  "Hello CD of the Month Club",
  "Hello Cleveland!",
  "Hep-Me Records",
  "Her Royal Majesty's Records",
  "Herald AV Publications",
  "Herald Records",
  "Heritage Records",
  "Hermes Records",
  "Herwin Records",
  "Hevy Devy Records",
  "Hi Life Recordings",
  "Hi Or Hey Records",
  "Hi Records",
  "Hi-n-Dry",
  "Hib-Tone",
  "Hickory Records",
  "Hidden Beach Recordings",
  "Hieroglyphics Imperium Recordings",
  "High Dive Records",
  "High Street Records",
  "High Water Recording Company",
  "Higher Ground Records",
  "Higher Octave",
  "Higher State",
  "Highland Records",
  "HighTone Records",
  "Hiljaiset Levyt",
  "HIM International Music",
  "Hip Records",
  "Hip-O Records",
  "Hipposonic Studios",
  "His Master's Voice",
  "Historic Masters",
  "Historical Records",
  "Hit of the Week Records",
  "Hitz Committee",
  "Hobbledehoy Record Co.",
  "Holiday Inn Records",
  "Holiday Records",
  "Hollywood Records",
  "Holy Roar Records",
  "Home Sweet Home Records",
  "Homespun Records",
  "Homestead Records",
  "Homestead Records (1920s)",
  "Honest Don's Records",
  "Honest Jon's",
  "Hoo-Bangin' Records",
  "Hope Music Group",
  "Hope Recordings",
  "Hopeless Records",
  "HopeStreet Recordings",
  "Hor Music",
  "Horizon Records",
  "Horris Records",
  "Horror House Entertainment.",
  "Hosanna! Music",
  "Hospital Records",
  "HOSS Records",
  "Hot Pot Music",
  "Hot Wax Records",
  "How's That Music",
  "HQ Recordings",
  "Hugpatch Records",
  "Human Imprint",
  "Humble Beast",
  "Humming Bird Records",
  "Hungaroton",
  "Hush Records",
  "Hushush",
  "Hut Records",
  "Hwem",
  "Hybris",
  "Hydra Head Records",
  "Hyperdub",
  "Hyperion Records",
  "Hyperium Records",
  "Hypertek Digital",
  "Hypnos",
  "Hypnotize Minds",
  "I Scream Records",
  "I.R.S. Records",
  "IAMSOUND Records",
  "Ice Age Entertainment",
  "Ice Records",
  "Ici, d'ailleurs...",
  "Idea Records",
  "Ideal Records",
  "Idol Records",
  "Ignition Records",
  "III Records",
  "Ill Flava Records",
  "Ill Will Records",
  "Ill.Skillz Recordings",
  "Illegal Art",
  "Illegal Musik",
  "Illegal Records",
  "Illuminating Technologies",
  "Imagen Records",
  "Imaginary Records",
  "Immediate Records",
  "Immortal Records",
  "Impact (New Zealand)",
  "Impact Records",
  "Impact Records (California)",
  "Imperial Records (1900) (U.S.)",
  "Imperial Records (1920) (U.K.)",
  "Imperial Records (1947 and 2006 U.S.)",
  "Imprint Records",
  "Impulse! Records",
  "Imputor?",
  "In Records (Australia)",
  "In Records (United States)",
  "In the Red Records",
  "In-Fidelity Recordings",
  "Incentive Records",
  "INCredible",
  "Incus Records",
  "Indecision Records",
  "Independiente Records",
  "Indestructible Record Company",
  "Indi Script Records",
  "Indianola Records",
  "Indirecto Records",
  "Industrial Records",
  "Infectious Records",
  "Infinity Cat Recordings",
  "Infinity Recordings",
  "Infrared",
  "Initial Records",
  "Inner Ear",
  "Innerground Music",
  "Innocent Records",
  "Innova Recordings",
  "INO Records",
  "Inoxia Records",
  "Inpop Records",
  "Inside Recordings",
  "InsideOut Music",
  "InsideOut US",
  "Instant Karma",
  "Instinct Records",
  "Intec Digital",
  "Integrity Records",
  "Intense Records",
  "Interactive Jack Records",
  "International Artists",
  "International DeeJay Gigolo Records",
  "Internet Money",
  "Interphon Records",
  "Interscope Records",
  "Interscope-Geffen-A&M",
  "Intrada Records",
  "Invictus Records",
  "Invisible Agent",
  "Invisible Hands Music",
  "Invisible Records",
  "inVogue Records",
  "Iodine Recordings",
  "Iona Records",
  "Ipecac Recordings",
  "Ironworks",
  "Isadora Records",
  "Island Blue Records",
  "Island Masters",
  "Island Records",
  "Island Reggae Greats",
  "Italians Do It Better",
  "It’s A Wonderful World Music Group",
  "Ivy League Records",
  "Ivy Queen Musa Sound",
  "J & S Records",
  "J Records",
  "J Storm",
  "J.O.B. Records",
  "Jackson Records",
  "JAD Records",
  "Jade Tree Records",
  "Jagjaguwar",
  "Jahtari",
  "Jamaican Gold",
  "Jamie Records",
  "Janus Records",
  "Jaro Medien",
  "Jarrah Records",
  "Jarring Effects",
  "Jasmine Records",
  "Jaus Records",
  "Javotti Media",
  "JAXART Records (U.S.)",
  "Jay Boy",
  "Jay-Jay Records",
  "JayTee Records",
  "Jazz Man Records",
  "Jazz, Ltd.",
  "Jazzaway Records",
  "Jazzland Records (1960) (U.S.)",
  "Jazzland Records (1997) (Norway)",
  "Jazzology Records",
  "JDC Records",
  "JDub Records",
  "Jeepster Records",
  "Jehova-Nisi Producciones",
  "Jellyfish Entertainment",
  "JEMP Records",
  "Jerden Records",
  "Jericho Beach Music",
  "Jester Records",
  "Jesuit Music Ministry",
  "Jet Records",
  "Jet Set Records",
  "Jetydosa",
  "Jewel Records (Cincinnati, Ohio)",
  "Jewel Records (New York)",
  "Jewel Records (Shreveport, Louisiana)",
  "Jewel Runners",
  "Jiggiri Records",
  "Jim Henson Records",
  "Jimmy Franks Recording Company",
  "Jive Electro",
  "Jive Records",
  "JMT Records",
  "Joe & Joey Records",
  "Johann's Face Records",
  "Johnny & Associates",
  "Joilicious Records",
  "Jolly Roger Records",
  "Josie Records",
  "Joyful Noise Recordings",
  "JSP Records",
  "Juana Records",
  "Jubilee Records",
  "Judd Records",
  "Judgement Records",
  "Jugoton",
  "Juice Box Records",
  "Juke Box Records",
  "Jumbo Records",
  "Jump Records",
  "Jungle Records",
  "Junior Boy's Own",
  "Justablip Records",
  "JYP Entertainment",
  "K Records",
  "K-BAHN",
  "K-tel Records",
  "K&K Verlagsanstalt",
  "Kahvi",
  "Kaifa Records",
  "Kairos",
  "Kalakuta Republic",
  "Kalan Müzik",
  "Kama Sutra Records",
  "Kanine Records",
  "Kapow Records",
  "Kapp Records",
  "Karmageddon Media",
  "Kedar Records",
  "Keen Records",
  "Kelp Records",
  "Kemado Records",
  "Kemosabe Records",
  "Kennis Music",
  "Kent Records",
  "Key Sounds Label",
  "KFM Records",
  "Ki/oon Music",
  "Kickball Records",
  "Kicking Mule Records",
  "Kid Stuff Records",
  "Kiddyphone",
  "Kill Rock Stars",
  "Kimi Records",
  "Kindercore Records",
  "Kinetic Records",
  "King Records (Japan)",
  "King Records (USA)",
  "King Worldwide",
  "Kirtland Records",
  "Kitchen Motors",
  "Kitchenware Records",
  "Kitsuné Music",
  "Kitty Kitty Corporation",
  "Kitty Play Records",
  "Kitty-Yo",
  "KLF Communications",
  "KMB Jazz",
  "Knee Deep Records",
  "Knitting Factory Records",
  "Knockout Entertainment",
  "Koch Distribution",
  "Koch Entertainment",
  "Koch Entertainment Canada",
  "Koch International Records",
  "Koch Publishing",
  "Kokomo Records",
  "Kompakt",
  "Kon Live Distribution",
  "Konichiwa Records",
  "Kontor Records",
  "Konvict Muzik",
  "Koolarrow Records",
  "Korova",
  "Kranky",
  "Kross Over Entertainment",
  "Kscope",
  "Kung Fu Records",
  "Kvitnu",
  "La Tribu",
  "Label Fandango",
  "Labrador Records",
  "LaFace Records",
  "Laff Records",
  "Lakeshore Records",
  "Lakeside Records",
  "Lamon Records",
  "Lanor Records",
  "LaSalle Records",
  "Last Gang Records",
  "Latent Recordings",
  "Latino Buggerveil",
  "Laundry Label",
  "Laurie Records",
  "Lava Records",
  "Le Grand Magistery",
  "Leader Records (UK)",
  "Leader Records (US)",
  "Leaf Hound Records",
  "Leathür Records",
  "Leedon Records",
  "Leeds Talk-O-Phone",
  "Leesta Vall",
  "LeFrak-Moelis Records",
  "Legacy Recordings",
  "Legendary Music",
  "Legion Records",
  "Legit Ballin'",
  "Lench Mob Records",
  "Lengua Armada Discos",
  "Lens Records",
  "Les Disques du Crepuscule",
  "Level Plane",
  "Lex Records",
  "LHI Records",
  "Liberation Music",
  "Liberation Records",
  "Liberty & Lament",
  "Liberty Music Shop Records",
  "Liberty Records",
  "Library Records",
  "Licking Fingers",
  "Lifeforce Records",
  "Light Organ Records",
  "Light Records",
  "Lil' Chief Records",
  "Limb Music",
  "Limelight Records",
  "Limp Records",
  "Lincoln Records",
  "Lingasong Records",
  "Linn Records",
  "Linus Entertainment",
  "Lion Music",
  "Lioness Records",
  "Lionheart Music Group",
  "Liquor and Poker Music",
  "Listenable Records",
  "Lithium",
  "Little David Records",
  "Little Marvel",
  "Little Wonder Records",
  "Lizard",
  "Lizard King Records",
  "Lo Recordings",
  "Lo-Fidelity Records",
  "Load Records",
  "Loaded Records",
  "Lobster Records",
  "LOCA Records",
  "Local Action",
  "Locked On Records",
  "Locomotive Music",
  "Locust Music",
  "LOEN Entertainment",
  "Lofton Creek Records",
  "Logo Records",
  "Lojinx",
  "London Records",
  "London-Sire Records",
  "Lonely Astronaut Records",
  "Lonesome Day Records",
  "Longhorn Records",
  "Longines Symphonette Society",
  "Loningisa",
  "Lookout! Records",
  "Loöq Records",
  "Loose Music",
  "Loose Records & Music",
  "Losen Records",
  "Lost & Lonesome Recording Co.",
  "Lost Highway Records",
  "Lost Language",
  "Lotuspike",
  "Loud Records",
  "Love Is My Velocity",
  "Love Minus Zero Recordings",
  "Love Police Records",
  "Love Records",
  "Love Renaissance",
  "LoveCat Music",
  "Lovely Music",
  "Loveway Records",
  "Low Life Records",
  "Low Transit Industries",
  "Lowercase People Records",
  "LRRC (Luddite Rural Recording Cooperative)",
  "LTM Recordings",
  "Lu Pine Records",
  "Luaka Bop",
  "Lucid Records",
  "Lucidsamples",
  "Lucky Eleven Records",
  "Lucky Four Records",
  "Lucky Records",
  "Lujo Records",
  "Luke Records",
  "Lumiere Records",
  "Lynx Entertainment",
  "Lyric Records (Germany)",
  "Lyric Records (US)",
  "Lyric Street Records",
  "Lyrita Recorded Edition",
  "M.A.C.E. Music",
  "M&G Records",
  "M3 Records",
  "Machete Music",
  "Machine Shop Recordings",
  "Machinery Records",
  "Mad Decent",
  "MAD Dragon Records",
  "Madhouse Records",
  "Madison Gate Records",
  "Madison Records",
  "Magic Bullet Records",
  "Magic Circle Music",
  "Magna Carta Records",
  "Magnanimous Records",
  "Magnatune",
  "Magnet Records",
  "Magpie Records",
  "Mailboat Records",
  "Mainstream Records",
  "Mainya Music",
  "Maison de Soul",
  "Majestic Record Corporation",
  "Majestic Records",
  "Majik Ninja Entertainment",
  "Major League Productions (MLP)",
  "Major Minor Records",
  "Mala Records",
  "Malaco Records",
  "Maltine Records",
  "MAM Records",
  "Mamlish Records",
  "Mammoth Records",
  "Man's Ruin Records",
  "Mango Records",
  "Manhattan Records",
  "Manifesto Records",
  "Manifold Records",
  "Manimal Vinyl",
  "Manna Music Inc",
  "Manor Records",
  "Manticore Records",
  "Mantra Recordings",
  "Manyc Records",
  "MapleMusic Recordings",
  "Maranatha! Music",
  "Marian Records",
  "Mariann Grammofon AB",
  "Marina Records",
  "Marine Parade Records",
  "Market Square Records",
  "Marlin Records",
  "Marmalade Records",
  "Marrakesh Records",
  "Marriage Records",
  "Marsalis Music",
  "Mas Flow Inc",
  "Mascot Records",
  "Mass Appeal Records",
  "mass mvmnt",
  "Massacre Records",
  "Mastercharge Records",
  "Masters of Hardcore",
  "Masterworks Broadway Records",
  "Masterworks Records",
  "Matador Records",
  "Matty Grooves Records",
  "Mau5trap",
  "Maverick Records",
  "Mavin Records",
  "Maxi Records",
  "Maybach Music Group",
  "MCA Nashville Records",
  "MCA Records",
  "Medallion Records",
  "Mediarts Records",
  "Mediaskare Records",
  "Medium Productions",
  "Mega Records",
  "Megaforce Records",
  "Megalith Records",
  "Megarock Records",
  "Mego",
  "Mello Music Group",
  "Melodeon Records",
  "Melodic Revolution Records",
  "Melodiya",
  "Melotone Records (Australia)",
  "Melotone Records (US)",
  "Meltdown Records",
  "Memento Materia",
  "Memorandum Recordings",
  "Memory Lane Music Group",
  "Memphis Industries",
  "Menart Records",
  "Merciful Release",
  "Merck Records",
  "Mercury Nashville Records",
  "Mercury Records",
  "Merge Records",
  "Meridian Records",
  "Meritt Records (1925)",
  "Meritt Records (1979)",
  "Mermaid Records",
  "Merovingian Music",
  "Messenger Records",
  "Metal Blade Records",
  "Metal Heaven",
  "Metal Mind Productions",
  "Metalheadz",
  "Metascope Records",
  "Meteor Records",
  "MeteorCity Records",
  "Metro Records",
  "Metroplex",
  "Metropolis Records",
  "MFS",
  "MGM Distribution",
  "MGM Records",
  "MicBurnerz Music",
  "Microphone Records",
  "Midas Records Nashville",
  "Middle Pillar Presents",
  "Midhir Records",
  "Midijum Records",
  "Midland International Records",
  "Mighty Atom Records",
  "Mighty Force Records",
  "Mikroton Recordings",
  "Mind of a Genius",
  "Milan Entertainment",
  "Milan Records",
  "Milestone Records",
  "Mille Pattes Records",
  "Mille Plateaux",
  "Millennium Records",
  "Mimosa",
  "Minimal Wave",
  "Ministry of Sound",
  "Minit Records",
  "Minotauro Records",
  "Mint Records",
  "Minty Fresh",
  "Minus",
  "Miracle Revival Recordings",
  "Mirage Records",
  "Misfits Records",
  "Misra Records",
  "Missing Link Records",
  "Mission Records",
  "Mistletone",
  "Mixpak Records",
  "MLD Entertainment (formerly Duble Kick Company)",
  "Mnemosyne Productions",
  "Mo Thugs Records",
  "Mo-Da-Mu",
  "Mo' Hits Records",
  "Mo' Wax",
  "Mobile Fidelity Sound Lab",
  "Moda Records",
  "Mode Records",
  "Modern Outsider",
  "Modern Records",
  "Modular Recordings",
  "Moist Music",
  "Mojo Records",
  "Mokum Records",
  "Mom + Pop Music",
  "MonarC Entertainment",
  "Mondo Music Corporation",
  "Mondo Records",
  "Monika Enterprise",
  "Monitor Records (New York)",
  "Mono Vs Stereo",
  "Monstercat",
  "Montalban Hotel",
  "Montauk Mantis",
  "Montgomery Ward Records",
  "Monument Records",
  "Moon Ska Records",
  "Moon Ska World",
  "Mooncrest Records",
  "Moonfog Productions",
  "Moonglow Records",
  "Moonshine Music",
  "Mordam Records",
  "Morr Music",
  "Morrison Records (Australia)",
  "Morrison Records (Seattle)",
  "Mortarhate Records",
  "Mosaic Records",
  "Moseley Shoals Records",
  "Moshi Moshi Records",
  "Moshpit Tragedy Records",
  "Mosley Music Group",
  "Mötley Records",
  "Motor Music Records",
  "Motown Records",
  "Mountain Apple Company",
  "Mountain Fever Records",
  "Mountain Home Records",
  "Mountain Records",
  "Mouseville",
  "Move Records",
  "Moving Shadow",
  "Mr Bongo Records",
  "Mr. Lady Records",
  "Mt. Fuji Records",
  "MTM Records",
  "Mudhoney Records",
  "Mulatta Records",
  "Multiply Records",
  "Multitone Records",
  "Mums Records",
  "Murder Inc. Records",
  "Murderecords",
  "Murmur",
  "Musart Records",
  "Mush Records",
  "Mushroom Records (Australia)",
  "Mushroom Records (Canada)",
  "Music Brokers",
  "Music for Nations",
  "Music for Pleasure",
  "Music from the Corner",
  "Music Maker",
  "Music of Life",
  "Music West Records",
  "Music70",
  "Musica Omnia",
  "Musical Freedom",
  "MusicMasters Records",
  "Musicor Records",
  "Musicraft Records",
  "Musidisc",
  "Mutant League Records",
  "Mutant Pop Records",
  "Mute Records",
  "My Pal God Records",
  "Myrrh Records",
  "MySpace Records",
  "Mystic Records",
  "N-Coded Music",
  "n5MD",
  "Nacional Records",
  "Naked Records",
  "Napalm Records",
  "Nappy Boy",
  "Narada Productions",
  "Nardis Records",
  "Narita Records",
  "Narnack Records",
  "Nation Records",
  "National Music Lovers Records",
  "National Recording Corporation",
  "National Records",
  "Native Language Music",
  "Native Records",
  "Nature Sounds",
  "Naxos Records",
  "Naxos World",
  "Neat Records",
  "Necropolis Records",
  "Nega Network",
  "Neighborhood Records",
  "Nemesis Records",
  "NEMS Enterprises (Argentina)",
  "Neon Gold Records",
  "Neptune Records",
  "Nervous Records (U.K.)",
  "Nervous Records (U.S.)",
  "netMusicZone Records",
  "Nettwerk",
  "Network 23",
  "Network Records",
  "Neurot Recordings",
  "Neutral Records",
  "New Alliance Records",
  "New Amsterdam Records",
  "New Earth Records",
  "New European Recordings",
  "New Orleans Records",
  "New Red Archives",
  "New Renaissance Records",
  "New Wave Productions",
  "New West Records",
  "Newhouse Records",
  "Newmemorabilia Records",
  "Nexsound",
  "Next Plateau Records",
  "Nextera",
  "Ngoma",
  "Nick Records",
  "Nicola Delita",
  "Nicotine Records",
  "Niezależna Oficyna Wydawnicza CDN",
  "Nighthawk Records",
  "Nightshade Productions",
  "Nihilist Records",
  "Nilaihah Records",
  "Ninja Tune",
  "Nitro Records",
  "Nixa Records",
  "NMC Music",
  "No Fans Records",
  "No Fashion Records",
  "No Idea Records",
  "No Limit Records",
  "No Masters",
  "No Milk Records",
  "No Records",
  "No Remorse Records",
  "NoCopyrightSounds",
  "Noh Poetry Records",
  "Noise Records",
  "Noisebox Records",
  "Nonesuch Records",
  "NorCD",
  "Nordic Steel",
  "Nordskog Records",
  "Northern Records",
  "NorthernBlues Music",
  "NorthSide",
  "Northwestside Records",
  "Norton Records",
  "Not Lame Recordings",
  "Nothing Records",
  "Nova Zembla",
  "Novamute Records",
  "Now-Again Records",
  "NPG Records",
  "Ntone",
  "NTT Publishing Co.",
  "Nuclear Blast",
  "Nude Records",
  "Nukleuz",
  "Numa Records",
  "Nuphonic",
  "NUX Organization",
  "Oasis Records",
  "Obese Records",
  "Oblivion Records",
  "OBR Records",
  "Octone Records",
  "Odd Future Records",
  "Ode Records",
  "Odeon Records",
  "Off Beat",
  "Off Centaur Publications",
  "OFWGKTA",
  "Og Music",
  "Oglio Records",
  "Ogopa DJs",
  "Ogun Records",
  "Oh Boy Records",
  "Oi! the boat records",
  "Okeh Records",
  "Old Europa Cafe",
  "Old Homestead Records",
  "Oldies-33",
  "Oldies-45",
  "Oliver Sudden Productions",
  "Olivia Records",
  "Om Records",
  "Omnivore Recordings",
  "On-U Sound Records",
  "OnClassical",
  "Ondine",
  "One Big Spark",
  "One Eleven Records",
  "One Little Indian Records",
  "One Records (Scotland)",
  "One Records (Serbia)",
  "One Way Records",
  "Open Bar Entertainment",
  "Open Road Recordings",
  "Open Sky Records",
  "Open World Entertainment",
  "Opera Rara",
  "Operaphone Records",
  "OPUS Records",
  "Or Records",
  "Orange Record Label",
  "Orange Records",
  "Orange Twin Records",
  "Orchid Tapes",
  "ORFEO",
  "Orfeón",
  "Origin Jazz Library",
  "Original Blues Classics",
  "Original Jazz Classics",
  "Original Sound",
  "Oriole Records (U.S.)",
  "Oriole Records (UK)",
  "Orion Records",
  "Orpheus Music",
  "Osmose Productions",
  "Out of Line Music",
  "Outlaw Recordz",
  "Outpunk",
  "Output Recordings",
  "Outside Music",
  "Outta Sight Records",
  "Ovation Records",
  "Overcoat Recordings",
  "OVO Sound",
  "Ovum Recordings",
  "Owl Studios",
  "Owsla",
  "Oxford Records",
  "Oxide Entertainment",
  "OxRecs DIGITAL",
  "Oxygen Music Works",
  "P.S.F. Records",
  "P572",
  "Pablo Records",
  "Pacific Front Recordings",
  "Pacific Jazz Records",
  "Pagan Records",
  "Page One Records",
  "Paid In Full Entertainment",
  "Painted Smiles",
  "Paisley Park Records",
  "Palette Records",
  "Palm Pictures",
  "Palm Records",
  "Palo Duro Records",
  "PAN",
  "Panart Records",
  "Pandisc Records",
  "Pangea Recordings",
  "Panhellenion Records",
  "Panic Button Records",
  "Panorama Records",
  "Panton Records",
  "Panzerfaust Records",
  "Paper and Glue",
  "Paper Bag Records",
  "Papillion Records",
  "Paracadute",
  "Parachute Records",
  "Paramount Music",
  "Paramount Records",
  "Paramount Records (1969)",
  "Parasol Records",
  "Park Records",
  "Parkwood Entertainment",
  "Parlophone",
  "Parrot Records",
  "Parrot Records (Chicago)",
  "Partee Records",
  "Partisan Records",
  "Pasadena Records",
  "Pathé Records",
  "Patuxent Music",
  "Paw Tracks",
  "Peacefrog Records",
  "Peaceville Records",
  "Peacock Records",
  "Peak Records",
  "Peanuts & Corn Records",
  "Pearl Records",
  "Peerless Records",
  "Penalty Records",
  "Pendragon Records",
  "Pendu Sound Recordings",
  "Penny Farthing Records",
  "Pentatone",
  "People Mountain People Sea",
  "People Records",
  "Pepper Records",
  "Perfect Game Recording Co.",
  "Perfect Havoc",
  "Perfect Records",
  "Perfecto Records",
  "Perhaps Transparent",
  "Perishable Records",
  "Perlon",
  "Perspective Records",
  "Peter Pan Records",
  "PGP-RTB",
  "PGP-RTS",
  "Phantasy Sound",
  "Phantom City Studios",
  "Phantom Records",
  "Pharmacy Records",
  "Phase 4 Stereo",
  "Phi-Dan Records",
  "Phil Spector International",
  "Philadelphia International Records",
  "Philips Classics Records",
  "Philips Records",
  "Philles Records",
  "Phillips International Records",
  "Philly Groove Records",
  "Philo Records (folk)",
  "Philo Records (rhythm & blues)",
  "Phono-Cut Record Company",
  "Phonogenic Records (UK)",
  "Phonogram Records",
  "Photo Finish Records",
  "Pi Recordings",
  "PIAS Recordings",
  "Piccadilly Records",
  "Piccolo Town",
  "Pickled Egg Records",
  "Pickwick Records",
  "Piedmont Records",
  "Pigs Whisker Music",
  "Pilz",
  "Pina Records",
  "Pinecastle Records",
  "Pink and Black Records",
  "Pinnacle Records",
  "Pipeline Music",
  "Pivotal Rockordings",
  "Placid Casual",
  "Plainisphare",
  "Plaka Pilipino",
  "Plan 9 Records",
  "Plan-It-X Records",
  "Planet Dog",
  "Planet Mu",
  "Planet Pimp Records",
  "Plant Life Records",
  "Plantation Records",
  "Plasma Records",
  "Plastic Raygun",
  "Plastiq Musiq",
  "Platform Records",
  "Platina Records",
  "Platipus Records",
  "Play It Again Sam",
  "Play Me",
  "Playground Music Scandinavia",
  "Playhouse Records",
  "Playing With Sound",
  "Playmaker Music",
  "Playtone",
  "Pledis Entertainment",
  "Plopscotch Records",
  "Plug Research",
  "Plus 8",
  "Pluto Records",
  "Pneuma Recordings",
  "Poe Boy Entertainment",
  "POF Music",
  "Point Blank Records",
  "Point Music",
  "Poison Ivy",
  "Polar Music",
  "Polen Records",
  "Polo Grounds Music",
  "Polydor Records",
  "Polygon Records",
  "PolyGram",
  "Polymorph Records",
  "Polyvinyl Record Co.",
  "Pompeii Records",
  "Ponca Jazz Records",
  "Pony Canyon",
  "Popfrenzy",
  "Popsicle Records",
  "Poptones",
  "Pork Recordings",
  "Portrait Records",
  "Posh Boy Records",
  "Positiva Records",
  "Positive Tone",
  "Positron! Records",
  "Post Records",
  "Postcard Records",
  "Potential Getaway Driver",
  "Power It Up Records",
  "Power Out",
  "Pravda Records",
  "Prawn Song Records",
  "Precision Talent",
  "Prelude Records",
  "President Records",
  "Pressure Sounds",
  "Prestige Records",
  "Prikosnovénie",
  "Primary Music",
  "Priority Records",
  "Priory Records",
  "Prism Records",
  "Private Music",
  "Private Stock Records",
  "Pro Era Records",
  "Probe Plus",
  "Probe Records",
  "Procrastinate! Music Traitors",
  "Production House Records",
  "Profane Existence Records",
  "Profile Entertainment",
  "Profile Records",
  "Profile Records (Chief Records subsidiary)",
  "Profound Lore Records",
  "Project 3 Records",
  "Project Blowed",
  "Projekt Records",
  "Propeller Recordings",
  "Propeller Records",
  "Propeller Records (Boston)",
  "Prophecy Productions",
  "Prophet Entertainment",
  "Prosthetic Records",
  "Prosto Records",
  "Protest Records",
  "Provogue Records",
  "PRT Records",
  "PS Classics",
  "PSI Records",
  "Psy-Harmonics",
  "Psycho+Logical-Records",
  "Psychomania Records",
  "Psychonaut Records",
  "Psychopathic Records",
  "Psychout Records",
  "Punk Core Records",
  "Purchase Records",
  "Pure Steel Records",
  "Puritan Records",
  "Purple Feather Records",
  "Purple Music Switzerland",
  "Purple Records",
  "Purple Ribbon Records",
  "PUSA Inc.",
  "Putumayo World Music",
  "PWL",
  "Pye Golden Guinea Records",
  "Pye International Records",
  "Pye Records",
  "Pyramid Gang Records",
  "Q Division Records",
  "QN5 Music",
  "QRS Records",
  "Qualiton",
  "Qualiton Records",
  "Quality Control Music",
  "Quality Records",
  "Quango Music Group",
  "Quannum Projects",
  "Quarterstick Records",
  "Que-so Records",
  "Queen Bee Entertainment",
  "Queen Records",
  "Quiet Storm Records",
  "Quinlan Road",
  "Quirkworks Laboratory Discs",
  "Quote Unquote Records",
  "Qwest Records",
  "R.E.X. Records",
  "R.I.P Society Records",
  "R&S Records",
  "Rabid Records",
  "Racetrack Records",
  "Radar Records",
  "Radiant Future Records",
  "Radiex Records",
  "Radikal Records",
  "Radioactive Records",
  "Ragged Flag",
  "Ragnarock",
  "Rainbow Records",
  "Rainy Day Records",
  "Rajon Music Group",
  "Rak Records",
  "Ralph Records",
  "Ram Records (UK)",
  "Ram Records (US)",
  "Rama Records",
  "RandM Records",
  "Range Life Records",
  "Ranwood Records",
  "Rap-a-Lot Records",
  "Rappers Rapp Records",
  "RAS Records",
  "Raster-Noton",
  "Raucous Records",
  "Raven Records",
  "Ravenous Records",
  "Raw Energy Records",
  "Rawkus Records",
  "Razor & Tie",
  "Razzia Records",
  "RCA Camden",
  "RCA Records",
  "RCA Red Seal Records",
  "RCA Victrola",
  "RCA/Jive Label Group",
  "Re-Constriction Records",
  "Re-Up Records",
  "Reach Records",
  "React Music Limited",
  "Reaction Records",
  "Ready Records",
  "Real Talk Entertainment",
  "Real World Records",
  "Rebel Records",
  "Rebelle Records",
  "Rebelles Européens",
  "Recess Records",
  "Recommended Records",
  "Recorded In Hollywood",
  "Recorte Records",
  "RecRec Music",
  "Red Beet Records",
  "Red Bird Records",
  "Red Bull Records",
  "Red Eye Records",
  "Red Girl Records",
  "Red Hammer Records",
  "Red House Records",
  "Red Melon Records",
  "Red Pajamas Records",
  "Red Robin Records",
  "Red Rooster Records",
  "Red Star Records",
  "Redline Records",
  "RedOne Records",
  "Reel Life Productions",
  "Reflective Records",
  "Reflex Records",
  "Refuge Records",
  "Regain Records",
  "Regal Records (1914) (UK)",
  "Regal Records (1920) (Spain)",
  "Regal Records (1921) (US)",
  "Regal Records (1949) (US)",
  "Regal Zonophone Records",
  "Regency Records",
  "Regent Records (UK)",
  "Regent Records (US)",
  "Reinforced Records",
  "Rejoice Records",
  "Rekabet Records",
  "Rekords Rekords",
  "Relapse Records",
  "Relativity Records",
  "Releasing Eskimo",
  "Relentless Records",
  "Remedy Records (UK)",
  "Remedy Records (US)",
  "Remington Records",
  "Remington-Morse Records",
  "Remote Control Records",
  "Renaissance",
  "Renaissance Recordings",
  "Repeat Records",
  "Repertoire Records",
  "Rephlex Records",
  "Reprise Records",
  "Republic Records",
  "Resipiscent",
  "Resist Music",
  "Resistance Records",
  "Resonance Records",
  "Restless Records",
  "Rethink",
  "Retroactive Records",
  "Reunion Records",
  "Rev-Ola Records",
  "Reveal Records Label",
  "Revealed Recordings",
  "Revelation Records",
  "Revenant Records",
  "Reverb Records",
  "Reverberation",
  "Revival Records",
  "Revolution Records",
  "Rex Records (1912) (US)",
  "Rex Records (1933) (UK)",
  "Rex Records (1957) (US)",
  "Rex Records (2001) (UK)",
  "RFUGrey",
  "Rhino Entertainment",
  "Rhymesayers Entertainment",
  "Rhythm King",
  "Rhythm Zone",
  "Rice Music",
  "Rich Forever Music",
  "Ridge Runner Records",
  "Righteous Babe Records",
  "Rikos Records",
  "Riot City Records",
  "Ripete Records",
  "Ripple Music",
  "Rise Above Records",
  "Rise Records",
  "Rising Tide Records",
  "Riva Records",
  "River Jones Music",
  "Riverside Records",
  "RKO/Unique Records",
  "remarQabl",
  "RMM Records & Video",
  "Roadrunner Records",
  "Rob's House Records",
  "Rob's Records",
  "Robbins Entertainment",
  "Robot Needs Home",
  "Robotic Empire",
  "Roc Nation",
  "Roc-A-Fella Records",
  "Roc-La-Familia",
  "Rock 'n Roll Records",
  "Rock Action Records",
  "Rock Bottom Entertainment",
  "Rock Records",
  "Rock Ridge Music",
  "Rock-O-Rama",
  "Rocket Girl",
  "Rocket Records",
  "Rocketown Records",
  "Rockland Records",
  "Rodven Records",
  "Rogue Music Alliance",
  "ROIR",
  "Rolling Stones Records",
  "Romeo Records",
  "Romophone",
  "Ron Johnson Records",
  "rooArt",
  "Roost Records",
  "Rooster Blues",
  "Ropeadope Records",
  "Rostrum Records",
  "Roswell",
  "Rotana",
  "Rotorelief",
  "Rotters Golf Club",
  "Rough Trade Records",
  "Roulé",
  "Roulette Records",
  "Rounder Records",
  "Route 66 Records",
  "Rowdy Records",
  "Roxy Recordings",
  "Royal Empire Records",
  "Royalty Records",
  "RPM Records (United Kingdom)",
  "RPM Records (United States)",
  "RRRecords",
  "RS Music",
  "RSO Records",
  "Rubber Jungle Records",
  "Ruby Records",
  "Rude Records",
  "Ruf Records",
  "Ruff Ryders Entertainment",
  "Ruffhouse Records",
  "RuffNation Records",
  "Run For Cover Records",
  "Rune Grammofon",
  "Rural Rhythm Records",
  "Rushmore Records",
  "Russell Simmons Music Group",
  "Rust Nashville",
  "Rust Records, NY",
  "Ruthless Records",
  "Ruthless Records (Chicago)",
  "Rykodisc",
  "S-Curve Records",
  "S. Carter Records",
  "S.M. Entertainment",
  "S2 Records",
  "S2S Pte. Ltd.",
  "Sabre Records",
  "Sacred Bones Records",
  "Sacred Records",
  "Saddle Creek Records",
  "Safehouse Records",
  "Saga Records",
  "Sähkö Recordings",
  "Sain",
  "Saja Records",
  "Salsoul Records",
  "Salted Music",
  "Samadhi Sound",
  "San Francisco Records",
  "Sanctuary Records",
  "Sandy Records",
  "Sappy Records",
  "SAR Records",
  "Sarah Records",
  "Sarathan Records",
  "Saravah",
  "Saregama",
  "Sargent House",
  "Satellite Records",
  "Sartorial Records",
  "Savannah Records",
  "Savoy Records",
  "Savvy Records",
  "Saw Recordings",
  "SBK Records",
  "Scantraxx Recordz",
  "Scared Records",
  "Scarlet Records",
  "Scat Records",
  "Scepter Records",
  "Schematic Records",
  "Schirmer Records",
  "Schism Records",
  "School Boy Records",
  "SCI Fidelity Records",
  "Science Friction",
  "Scion Audio/Visual",
  "Scitron",
  "Scotti Brothers Records",
  "Scratchie Records",
  "Screwgun Records",
  "Season of Mist",
  "Seclusiasis",
  "Secret City Records",
  "Secret Records",
  "Secretly Canadian",
  "Sedimental",
  "See For Miles Records",
  "See Thru Broadcasting",
  "Seed Records",
  "Seeland Records",
  "Select Records",
  "Selectric Records",
  "Selegna Records",
  "Self Immolation",
  "Selfmade Records",
  "Sequel Records",
  "Seraphim Records",
  "Serio Controla Records",
  "Serious Business Records",
  "Serjical Strike Records",
  "Service",
  "Setanta Records",
  "Seventh Rule Recordings",
  "Several Reasons",
  "Severn Records",
  "Sh-K-Boom Records",
  "Shadow Records",
  "Shady Records",
  "Shanachie Records",
  "Sheeba Records",
  "Sheer Sound",
  "Shelflife Records",
  "Shelter Records",
  "Shifty Records (South Africa)",
  "Shifty Records (USA)",
  "Shimmy Disc",
  "Shinkansen Records",
  "Shitkatapult",
  "Sho'nuff Records",
  "Shock Records",
  "Shogun Audio",
  "Shout Records",
  "Show Dog Nashville",
  "Shrapnel Records",
  "Shrimper Records",
  "Sic Squared Records",
  "Sick Room Records",
  "Side One Recordings",
  "SideCho Records",
  "SideOneDummy Records",
  "Sidewalk Records",
  "Sierra Records",
  "Sigma Editions",
  "Signature Records",
  "Signature Sounds Recordings",
  "Silas Records",
  "Silence Records",
  "Silkheart Records",
  "Siltbreeze",
  "Silver Planet",
  "Silvertone Records (1905) (US)",
  "Silvertone Records (1980) (UK)",
  "Silvertone Records (Selfridges) (UK)",
  "SimG Records",
  "Simian Records",
  "Sims Records",
  "Sinnbus",
  "Sire London Records",
  "Sire Records",
  "Sister Benten Online",
  "Situation Two",
  "Six Degrees Records",
  "Six Shooter Records",
  "Sixsevenine",
  "sixstepsrecords",
  "Ska Satellite Records",
  "Skam Records",
  "Skeleton Crew",
  "Skin Graft Records",
  "Skint Records",
  "Skirl Records",
  "Skunk Records",
  "Sky and Trees Records",
  "Sky Records",
  "Skybucket Records",
  "Skylite",
  "Slam Dunk Records",
  "Slampt",
  "Slash Records",
  "Slate Creek Records",
  "Slave Pit Records",
  "Sledgehammer Blues",
  "Sleep It Off Records",
  "Sleeping Bag Records",
  "Slip-N-Slide Records",
  "Slowdime Records",
  "Small Stone Records",
  "Small Wonder Records",
  "Smalltown America",
  "Smalltown Superjazzz",
  "Smalltown Supersound",
  "Smash Records",
  "Smash The House",
  "Smells Like Records",
  "Smithsonian Folkways Recordings",
  "Smoke-A-Lot Records",
  "Snail Records",
  "Snakes & Ladders Records",
  "Snapper Music",
  "Sniper Records",
  "SNOtone",
  "So So Def Recordings",
  "SoBe Entertainment",
  "Socialist Roots Sound System",
  "Softdrive Records",
  "SOLAR Records",
  "Soleilmoon",
  "Solid Rock Records",
  "Solid State Records (Christian metal)",
  "Solid State Records (jazz)",
  "Solitary Man Records",
  "Soma Quality Recordings",
  "Soma Records",
  "Some Bizzare Records",
  "SonaBLAST! Records",
  "Sonar Kollektiv",
  "Song Bird Records",
  "Sonic Past Music",
  "Sonic Unyon Recording Company",
  "Sonic Wave America",
  "Sonic Youth Recordings",
  "Sonic360 Records",
  "Sons Ltd",
  "Sony BMG",
  "Sony BMG Masterworks",
  "Sony Classical Records",
  "Sony Music Entertainment",
  "Sony Music Entertainment Japan",
  "Sony Music India",
  "Sony Music Special Products",
  "Sony Records",
  "Sony Wonder",
  "Sony/ATV Music Publishing",
  "Sordide Sentimental",
  "Soul City Records",
  "Soul Jazz Records",
  "Soulfuric Recordings",
  "Soulseek Records",
  "Soulection",
  "Sound Circus",
  "Sound Document",
  "Sound of Gospel",
  "Sound Riot Records",
  "Sound Stage 7",
  "Sound System Records",
  "Sounds Are Active",
  "Soundway Records",
  "South Indies",
  "Southern Empire Records",
  "Southern Fried Records",
  "Southern Lord Records",
  "Southern Records",
  "Southern Studios",
  "Southland Records",
  "Spaghetti Records",
  "Spalax",
  "Spare Me Records",
  "Spark Records",
  "Sparrow Records",
  "Sparrowheart Music",
  "Spartan Records",
  "Specialty Records",
  "Spectral Sound",
  "Speed Label",
  "Spiderleg Records",
  "Spin Records (Australia)",
  "Spin Records (US)",
  "Spinalonga Records",
  "spinART Records",
  "Spinefarm Records",
  "Spinnin' Records",
  "Spinnup",
  "Spirit Zone Records",
  "Spit Shine Records",
  "Spitfire Records",
  "Spivey Records",
  "Spoon Records",
  "Spotlite Records",
  "Spring Hill Music Group",
  "Springman Records",
  "SPV GmbH",
  "Squint Entertainment",
  "SRC Records",
  "SST Records",
  "St. George Records",
  "Staalplaat",
  "Stacks on Deck Entertainment",
  "Stage Door Records",
  "Stamps-Baxter Music Company",
  "Stand Up! Records",
  "Standard Deviation",
  "Standard Talking Machine Company",
  "StandBy Records",
  "Star Music (Philippines)",
  "Star Recordings",
  "Star Song Communications",
  "Star Trak Entertainment",
  "Starboy Entertainment",
  "Starday Records",
  "Stardust Promotion",
  "Starkland",
  "Starr Records",
  "Starship Entertainment",
  "Starstream Records",
  "Startime International",
  "States Records",
  "Stateside Records",
  "Static Caravan Recordings",
  "Stax Records",
  "STC Recordings",
  "Stealth Records",
  "Steed Records",
  "Steel Tiger Records",
  "Steelpride Records",
  "Steeltown Records",
  "Steelwork Maschine",
  "Step One Records",
  "Stereolaffs",
  "Sterile Records",
  "Sterling Records (Sweden)",
  "Sterling Records (US)",
  "Sterno Records",
  "Stickfigure Records",
  "Stidham Records",
  "Stiff Records",
  "Stigmata",
  "Stillborn Records",
  "Stmpd Rcrds",
  "Stockfisch Records",
  "Stockholm Records",
  "Stolen Recordings",
  "Stomp Records",
  "Stone Records",
  "Stone'd Records",
  "Stones Throw Records",
  "Stony Plain Records",
  "Storch Music Company",
  "Storyville Records",
  "Storyville Records (George Wein's)",
  "Straight Records",
  "Strange Famous Records",
  "Strange Fruit Records",
  "Strange Music",
  "Strange Ways",
  "Strata Music",
  "Strata-East Records",
  "Street Records Corporation",
  "StreetSounds",
  "Streetsweepers Entertainment",
  "Strictly Rhythm",
  "Studio !K7",
  "Studio One",
  "Studioseven Recordings",
  "Stunt Records",
  "Stupak Records",
  "Suave House Records",
  "Sub City Records",
  "Sub Pop",
  "Sub Rosa",
  "Sub Verse Records",
  "Sub•Lime Records",
  "Subconscious Communications",
  "Sublime Frequencies",
  "Subliminal",
  "Submerged Records",
  "Subplate Records",
  "Subterranean Records",
  "Suburban Base",
  "Suburban Home Records",
  "Suburban Noize Records",
  "Suburban Records",
  "Suburban Sprawl Music",
  "Such-A-Punch Media",
  "Suckapunch Records",
  "Sudden Death Records",
  "Sue Records",
  "Sugar Hill Records (bluegrass)",
  "Sugar Hill Records (rap)",
  "Suleputer",
  "Sumerian Records",
  "Summersteps Records",
  "Summit Records",
  "Sumthing Distribution",
  "Sun Records",
  "Suncity Records",
  "Sundazed Records",
  "Sunflower Records",
  "Sunset Alliance",
  "Sunset Records",
  "Sunshine Records (Australia)",
  "Sunshine Records (USA)",
  "Suntrip Records",
  "Suomen Musiikki",
  "Super Records",
  "Supernal Music",
  "Supersoul Records",
  "Supertone Records",
  "Supraphon",
  "Supreme Records (Grey Gull subsidiary)",
  "Supreme Records (Los Angeles)",
  "Supreme Records (Pama subsidiary)",
  "Supreme Records UK",
  "Surfdog Records",
  "Surprise Attack Records",
  "Surprise Records",
  "Survivor Records",
  "Sussex Records",
  "Sutemos",
  "Sutton Records",
  "Suzy",
  "SVR Producciones",
  "Swallow Records",
  "Swami Records",
  "Swan Records (jazz label)",
  "Swan Records (Philadelphia, PA)",
  "Swan Song Records",
  "Sweet Lucy Records",
  "Swing Time Records",
  "Swishahouse",
  "Sword Records",
  "Syco Music",
  "Sympathy for the Record Industry",
  "Synthetic Sounds",
  "T-Neck Records",
  "T-Series",
  "T.A. Music",
  "Taang! Records",
  "Table of the Elements",
  "Tabu Recordings",
  "Tabu Records",
  "TAG Recordings",
  "Take Fo' Records",
  "Takeover Records",
  "Takoma Records",
  "Talitres",
  "Talkin' Loud",
  "Tall Poppies Records",
  "Talos Records",
  "Tamla Records",
  "Tan Cressida",
  "Tangerine Records (1963) (US)",
  "Tangerine Records (1992) (UK)",
  "Tankcrimes",
  "TANZA (New Zealand)",
  "Tapete Records",
  "Tara Music label",
  "Tarantulas Records",
  "Tarantura",
  "Taste Media",
  "Taylor Gang Records",
  "Tayster and Rojac Records",
  "TCR",
  "Tea Pot Records",
  "Team Love",
  "Tee Pee Records",
  "Tee Productions",
  "Tee Records",
  "Teem Records",
  "Teenage USA Recordings",
  "TeenBeat Records",
  "Teichiku Records",
  "Telarc International Corporation",
  "Teldec Record Service",
  "Teleprompt Records",
  "Tellus Audio Cassette Magazine",
  "Telstar Records",
  "Tempa",
  "Temple Records (1978 UK label)",
  "Temple US Records",
  "Tempo Records (UK)",
  "Tempo Records (US)",
  "Temporary Music",
  "Temporary Residence Limited",
  "TEN Music Group",
  "Ten12 Records",
  "Tender Loving Empire",
  "Tennessee Records",
  "Tent Show Records",
  "Terror Squad",
  "Tesco Organisation",
  "Test Tube Records",
  "Testament Records (UK)",
  "Testament Records (USA)",
  "Tetragrammaton Records",
  "Tetrapod Spools",
  "Texas Hotel Records",
  "The Amazing Kornyfone Record Label",
  "The Bedtime Record",
  "The Black Wall Street Records",
  "The C Kunspyruhzy",
  "The Control Group",
  "The Elephant 6 Recording Company",
  "The End Records",
  "The Flenser",
  "The Ford Plant",
  "The Goldmind Inc.",
  "The Groove Thing",
  "The Inc. Records",
  "The Island Def Jam Music Group",
  "The Leaf Label",
  "The Meny-X",
  "The Militia Group",
  "The Moonshine Conspiracy",
  "The Music Cartel",
  "The Noise Company",
  "The Orchard",
  "The Post War Blues",
  "The Reverberation Appreciation Society",
  "The Rocket Record Company",
  "The Social Registry",
  "The Ultimate Group",
  "The Unilalia Group",
  "The Viper Label",
  "The Winner Records",
  "Thee Sheffield Phonographic Corporation",
  "Thick Records",
  "Thick Syrup Records",
  "Think Music Records",
  "Thinner",
  "Third Man Records",
  "Third Mind Records",
  "Thirsty Ear Recordings",
  "This Is American Music",
  "Thizz Entertainment",
  "Three Gut Records",
  "Three One G",
  "Threshold House",
  "Threshold Records",
  "Thrill Jockey",
  "Thug Line Records",
  "Thump Records",
  "Tiara Records",
  "Tico Records",
  "Tiger Lily Records",
  "Tiger Style Records",
  "Tigerbeat6",
  "Tigersushi Records",
  "Tigertrap Records",
  "Timberyard Records",
  "Time Bomb Recordings",
  "Time Records",
  "Time-Lag Records",
  "Time–Life",
  "Tino Corp.",
  "Tiny Dog Records",
  "Tiny Evil Records",
  "Tirk Records",
  "Titanic Records",
  "TK Records",
  "To the Fallen Records",
  "Toast Hawaii",
  "Todamerica Records",
  "Toes in the Sand Recordings",
  "Tofu Records",
  "Tokuma Shoten",
  "Tokyo Dawn Records",
  "Tollie Records",
  "Tomato Head Records",
  "Tombstone Records",
  "Tomlab",
  "Tommy Boy Records",
  "Tompkins Square Records",
  "Too Pure",
  "Tooth & Nail Records",
  "Top Dawg Entertainment",
  "Top Rank Records",
  "Topic Records",
  "TopTen",
  "Toshiba-EMI",
  "Tôt ou tard",
  "Touch and Go Records",
  "Touch Records",
  "Tower Records",
  "Tr1be Records",
  "Track Records",
  "Trademark of Quality",
  "Tradisom",
  "Tradition Records",
  "Trance Syndicate",
  "Trans Continental Records",
  "Transatlantic Records",
  "Transcopic Records",
  "Transgressive Records",
  "Transmat",
  "Transmission Communications",
  "Trash Aesthetics",
  "Trash Art!",
  "Trattoria Records",
  "Traum Schallplatten",
  "Trauma Records",
  "Trax Records",
  "Trekky Records",
  "trend is dead! records",
  "Trend Records",
  "Trensmat Records",
  "Trente Oiseaux",
  "Tres Records",
  "Tresor",
  "Trial & Error Records",
  "Tribe Records",
  "Tribe Records (NO)",
  "Tribute Records",
  "Trickdisc Recordings",
  "Trifekta",
  "Trikont",
  "Trill Entertainment",
  "Triple Crown Records",
  "Trisol Music Group",
  "Triumph Records (UK)",
  "Triumph Records (US)",
  "Trix Records",
  "Trojan Records",
  "Troubleman Unlimited Records",
  "Trout Music",
  "Tru 'Dat' Entertainment",
  "Tru Thoughts",
  "Truck Records",
  "True North Records",
  "True Panther Sounds",
  "True Tone Records",
  "Trumpet Records",
  "Trumpet Swan Productions",
  "Trunk Records",
  "Trust in Trance Records",
  "Trustkill Records",
  "Try Me Records",
  "TSOP Records",
  "TSR Records",
  "Tuff City Records",
  "Tuff Gong",
  "Tug Records",
  "Tumi Music",
  "Tumult Records",
  "Tunnel Records",
  "Tutl",
  "TVT Records",
  "Twin/Tone Records",
  "Twisted Nerve Records",
  "Twisted Records (UK)",
  "Twisted Records (US)",
  "Tyscot Records",
  "Tzadik Records",
  "Ubiquity Records",
  "Ugly Man Records",
  "Ugly Nephew Records",
  "UHD&C Record Company",
  "Ujikaji",
  "UK Records",
  "Ultimae Records",
  "Ultra Records",
  "Umami Records",
  "UMTV",
  "Unable Records",
  "Unart Records",
  "Uncensored Records",
  "Uncle Howie Records",
  "Unda K9 Records",
  "Under One Flag",
  "Undercover Prodigy",
  "Undergroove Records",
  "Underground Operations",
  "Underground Resistance",
  "UNESCO Collection",
  "UNFD",
  "Unholy Records",
  "Uni Records",
  "Unicorn Digital",
  "Unicorn-Kanchana",
  "Unidisc Music Inc.",
  "Union City Recordings",
  "Union Label Group",
  "United Artists Records",
  "United Masters",
  "United Records",
  "United Records (1910s)",
  "United Telefilm Records",
  "Universal Classics Group",
  "Universal Edition",
  "Universal Motown Records Group",
  "Universal Music Group",
  "Universal Music India",
  "Universal Music Latin Entertainment",
  "Universal Records",
  "Universal South Records",
  "University Recording Company",
  "Univision Music Group",
  "Unlockedgroove",
  "Unstable Ape Records",
  "Up Above Records",
  "Up Records",
  "UpFront Records",
  "Uppity Cracker",
  "Uprising Records",
  "Upsetter Records (Jamaica)",
  "Upsetter Records (USA)",
  "Upside Records",
  "Uptown Records",
  "Urban Jungle",
  "Urban Records",
  "URBNET Records",
  "Urgent! Records",
  "Urinine Records",
  "US Records",
  "Utech Records",
  "Utopia Records",
  "UTP Records",
  "UZI Suicide",
  "V Recordings",
  "V-Disc",
  "V.I.P. Records",
  "V.I.S.A.",
  "V/Vm Test Records",
  "V2 Records",
  "Vagrant Records",
  "Valcour Records",
  "Valiant Records",
  "Valley Entertainment",
  "Valley Records",
  "Valve Records",
  "Van Dyke Records",
  "Vandit",
  "Vanguard Records",
  "VAP (Video & Audio Project)",
  "Varèse-Sarabande Records",
  "VAWS (Verlag und Agentur Werner Symanek)",
  "VDE-Gallo Records",
  "VEB Deutsche Schallplatten",
  "Vee-Jay Records",
  "Velour Recordings",
  "Velvet Blue Music",
  "Velvet Tone Records",
  "Vena Records",
  "Vendetta Records",
  "Vendlus Records",
  "Verity Records",
  "Vermin Scum",
  "Vertigo Records",
  "Verve Records",
  "Very GOOD Beats",
  "Very Small Records",
  "VI Music",
  "Vicious Vinyl",
  "Victoria Records (1952)",
  "Victory Records",
  "Vik Records",
  "ViK. Recordings",
  "Villain Entertainment",
  "Villar Records",
  "Vim Records",
  "Vinyl Solution",
  "Virgin Records",
  "Virgin Schallplatten",
  "Virt Records",
  "Visible Noise",
  "Vision Quest Records",
  "Visionary Music Group",
  "Vitamin Records",
  "Viva Records",
  "Viva Records (Philippines)",
  "Vocalion Records",
  "Vogue Records",
  "Voiceprint Records",
  "Voices of Wonder",
  "Volcano Entertainment",
  "Volcom Entertainment",
  "Volition Records",
  "Volt Records",
  "Vox Records",
  "Vox Records (Germany)",
  "VP Records",
  "Wackies",
  "Waerloga Records",
  "Wagram Music",
  "Waldorf Music Hall Records",
  "Wall of Sound",
  "Wallis Original Records",
  "Walt Disney Records",
  "Wand Records",
  "Wanker Records",
  "Warcon Enterprises",
  "Warm Fuzz Records",
  "Warm Records",
  "Warner Alliance",
  "Warner Curb Records",
  "Warner Music Australasia",
  "Warner Music Canada",
  "Warner Music Group",
  "Warner Records",
  "Warner-Spector Records",
  "Warp Records",
  "Warwick Records (United Kingdom)",
  "Warwick Records (United States)",
  "Water Lily Acoustics",
  "Waterbug Records",
  "Waterfront Records",
  "Watermelon Records",
  "WaterTower Music",
  "WAU! Mr. Modo Recordings",
  "Wave Music",
  "Waveform Records",
  "Wax Trax! Records",
  "Waxploitation Records",
  "We Put Out Records",
  "WE R Music",
  "We The Best Music",
  "Weathermaker Music",
  "Web Entertainment",
  "Webco Records",
  "Wedge Records",
  "WEDIDIT",
  "Weed Records",
  "Weewerk",
  "Welk Music Group",
  "WERGO",
  "Werk Discs",
  "West Craft Records",
  "West Records",
  "Westbound Records",
  "Westminster Records",
  "Westpark Music",
  "Westport Records",
  "Westside Records",
  "WGNS Recordings",
  "What Have You Records",
  "What Records",
  "What? Records",
  "Whirlin' Disc Records",
  "White Noise Records",
  "White Pine Music",
  "White Whale Records",
  "Whitehaus Family Record",
  "Whitfield Records",
  "Why Not Records",
  "Wichita Recordings",
  "Wiiija",
  "Wilbury Records",
  "Wild Pitch Records",
  "Wild Rags",
  "Wildside Records",
  "Wildstar Records",
  "Willowtip Records",
  "Wind Music",
  "Wind-Up Records",
  "Windfall Records",
  "Windham Hill Records",
  "Wing Records",
  "Winley Records",
  "Winter & Winter",
  "Witches Brew",
  "WM Recordings",
  "WMOT Records",
  "WOLV Records",
  "Wooden Nickel Records",
  "Woodrich Records",
  "Woodsist",
  "Woodworm Records",
  "Woof Records",
  "Woollim Entertainment",
  "Word Records",
  "Work Records",
  "Workerbee Records",
  "Workshop Jazz Records",
  "World Circuit",
  "World Domination Recordings",
  "World Record Club",
  "World Serpent Distribution",
  "Wounded Bird Records",
  "WOW Music",
  "Wrasse Records",
  "Wrath Records",
  "WTII Records",
  "Wu-Tang Records",
  "WWE Records",
  "WY Records",
  "Wyncote Records",
  "Wynona Records",
  "Xanadu Records",
  "Xemu Records",
  "Xenophile Records",
  "XIII Bis Records",
  "XL Recordings",
  "XO Records",
  "Xpressway",
  "XRECORDS (record Label) distributed by Malaco",
  "Xtra Mile Recordings",
  "Xtreem Music",
  "XYZ Records",
  "Y Records",
  "Yambo Records",
  "Yazoo Records",
  "YB Music",
  "YBNL Nation",
  "YEAR0001",
  "Yellow Tail Records",
  "Yellow Van Records",
  "Yep Roc Records",
  "Yer Bird Records",
  "YG Entertainment",
  "Yoshitoshi Records",
  "Young God Records",
  "Young Money Entertainment",
  "Young Turks",
  "YSL Records",
  "Yuletide Records",
  "Zarape Records",
  "Zarjazz",
  "ZE Records",
  "Zebra Records",
  "Zee Music Company",
  "Zell's Records",
  "Zéro Musique",
  "Zero Records",
  "Zomba Recording",
  "Zone 4",
  "Zonophone Records",
  "Zoo Entertainment",
  "Zoom Lens",
  "Zoth Ommog Records",
  "ZTT Records",
  "Zunior",
  "ZYX Music",
  "Other"
]

export const Distributor = [
  "Absolute",
  "Alternative Distribution Alliance",
  "Amuse",
  "AvidPlay",
  "Awal",
  "Bandcamp",
  "Beatchain",
  "Believe Digital",
  "Boost Collective",
  "Caroline International",
  "CDbaby",
  "Consolidated Independent",
  "DistroKid",
  "Ditto music",
  "FreeMusicDistribution.com",
  "Fresh Tunes",
  "Fuga",
  "Horus Music",
  "Idol",
  "iMusician Digital",
  "INgrooves",
  "Kudos Distribution",
  "Label Engine",
  "Label Worx",
  "LabelGrid",
  "Landr",
  "Level Music",
  "Listn",
  "Mondo Tunes",
  "Music Gateway",
  "Music Info",
  "MusicDiffusion",
  "Octiive",
  "OneRPM",
  "Record Union",
  "Redeye Worldwide",
  "Repost Network",
  "Reverbnation",
  "Routenote",
  "Songcast",
  "SongCast",
  "SongTradr",
  "Sonomo",
  "Sonosuite",
  "Soundrop",
  "Soundtrap",
  "SpareMusic",
  "Spinnup Music",
  "Stem Music",
  "Symphonic",
  "The Orchard",
  "Triple Vision",
  "TuneCore",
  "United Masters",
  "Other"
]